/* eslint-disable */
import React, { useContext, useEffect, useRef, useState, useCallback } from "react";
import styled from "styled-components";

import { Grid, Column } from "../../../../theme/Grid";
import Button from "../../../../theme/Button";
import Input from "../../../../theme/CustomMUI/Input";
import Select from "../../../../theme/CustomMUI/Select";
import AlertDialog from "../../../../theme/CustomMUI/AlertDialog";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import MaskedInput from "../../../../theme/CustomMUI/MaskedInput";
import BetweenTimeGenerator from "../../../../functions/BetweenTimeGenerator";
import CSwitch from "../../../../theme/CustomMUI/CSwitch";
import { toast } from "react-toastify";
import moment from "moment";
import { Alert } from "@material-ui/lab";
import {
  AddBox,
  AddOutlined,
  Person,
  Phone,
  Comment,
  Search,
  Payment,
  Receipt,
  Sms,
  Delete,
  Save,
  Warning,
  AddCircle,
} from "@material-ui/icons";
import CalculateMessageCharCount from "../../../../functions/CalculateMessageCharCount";
import ReactToPrint from "react-to-print";

import Cash from "../../../../assets/images/svg/cash.svg";
import Credit from "../../../../assets/images/svg/credit.svg";
import Transfer from "../../../../assets/images/svg/transfer.svg";
import CustomerPoint from "../../../../assets/images/svg/customer_point.svg";
import CashWhite from "../../../../assets/images/svg/cash_white.svg";
import CreditWhite from "../../../../assets/images/svg/credit_white.svg";
import CustomerPointWhite from "../../../../assets/images/svg/customer_point_white.svg";
import TransferWhite from "../../../../assets/images/svg/transfer_white.svg";
import RemainingDebt from "../../../../assets/images/svg/remaining_debt.svg";
import RemainingDebtRed from "../../../../assets/images/svg/remaining_debt_red.svg";
import ReceiptOrange from "../../../../assets/images/svg/Receipt-orange.svg";
import PaymentGreen from "../../../../assets/images/svg/payment-green.svg";
import Debt from "../../../../assets/images/svg/debt.svg";
import Iyzico from "../../../../assets/images/svg/iyizico-logo.svg";
import StaffSelect from "../../../../theme/CustomMUI/StaffSelect";
import { Tooltip } from "@material-ui/core";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import FullScreenDialog from "../../../../theme/CustomMUI/FullScreenDialog";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import AppContext from "../../../../context/store";
import {
  _ContractDialogContracts,
  ContractDialogCreateNewContract,
  _ContractDialogEntrance,
  _ContractDialogUploadContract,
} from "./ContractComponents";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomerSearchInput from "../../../../theme/CustomMUI/CustomerSearchInput";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const themeForDatePicker = createTheme({
  typography: {
    fontSize: 11,
  },
});

const theme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: "white",
        boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
      },
    },
  },
});

/**
 * Adisyonun üst alanındaki müşteri bilgileri, değişiklikleri kaydet buttonu gibi componentlerin gösterildiği alan.
 */
export const ReceiptHeadingBuilder = ({
  contract_tab,
  setContractTab,
  newAgreementDetail,
  setNewAgreementDetail,
  file,
  setFile,
  checkout_data,
  print_dialog,
  setPrintDialog,
  getCustomerAgreements,
  customer,
  staffs,
  services,
  stock_items,
  getAllTotalService,
  getTotalAmounts,
  sex,
  is_change,
  contract_dialog,
  setContractDialog,
  getAgreements,
  getClauses,
  contract_info_id_number,
  setContractInfoIdNumber,
  contract_info_tax_number,
  setContractInfoTaxNumber,
  contract_info_address,
  setContractInfoAddress,
  selected_pattern,
  setSelectedPattern,
  contract_patterns,
  selected_agreement_dialog_show,
  setSelectedAgreementDialogShow,
  contract_info_ful_name,
  setContractInfoFulName,
  contract_info_phone,
  setContractInfoPhone,
  contract_patterns_wo_clauses,
  logo_src,
  staffArr,
  servicesArr,
  clauses,
  Signature,
  content_to_signiture,
  setContentToSigniture,
  send_to_signiture_aproval_modal,
  setSendToSignitureAprovalModal,
  sendAgreementToMobile,
  agreement_customer_for_receipt,
  setAgreementCustomerForReceipt,
  agreement_title,
  setAgreementTitle,
  uploadAgreement,
  customer_agreements,
  agreement_load,
  pagination_agreement,
  wp_aproval_modal,
  setWpAprovalModal,
  send_wp_id,
  setSendWpId,
  send_wp_customer_name,
  setSendWpCustomerName,
  send_wp_agreement_name,
  setSendWpAgreementName,
  sms_aproval_modal,
  setSmsAprovalModal,
  send_sms_id,
  setSendSmsId,
  send_sms_customer_name,
  setSendSmsCustomerName,
  send_sms_agreement_name,
  setSendSmsAgreementName,
  delete_agreement_dialog,
  setDeleteAgreementDialog,
  sendSMSAgreement,
  sendWPAgreement,
  agreement_delete_id,
  setAgreementDeleteId,
  deleteAgreement,
  validateTCKN,
  getServices,
  getStaff,
  setAgreementDetail,
  receipt_note
}) => {
  const context = useContext(AppContext);
  const history = useHistory();

  const ContractDialogEntrance = _ContractDialogEntrance;

  const ContractDialogUploadContract = _ContractDialogUploadContract;
  const ContractDialogContracts = _ContractDialogContracts;
  const [noteDialog, setNoteDialog] = useState(false)
  const [noteSelected, setNoteSelected] = useState(null)

  const printRef = useRef();
  return (
    <Grid className="no-gutters-row ml-3 mr-3">
      <AlertDialog
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <span
              style={{
                width: "120%",
                marginTop: "15px",
              }}
            >
              {context.t(`receipt.create.printButtonTitle`)}
            </span>
          </div>
        }
        open={noteDialog}
        closeHandler={() => setNoteDialog(false)}
        fullWidth
        maxWidth="sm"
        buttons={[
          {
            //title: context.t(`appointments.create.discardButtonTitle`),
            title: 'Evet gözüksün',
            icon: "close",
            backgroundColor: "green",
            style: {
              height: "56px",
            },
            textColor: "white",
            onClick: () => {
              setNoteSelected(true)
              setNoteDialog(false)
              setPrintDialog(true)
            },
          },
          {
            //title: context.t(`appointments.create.discardButtonTitle`),
            title: 'Hayır gözükmesin',
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => {
              setNoteSelected(false)
              setNoteDialog(false)
              setPrintDialog(true)
            },
          },
        ]}
      >
        <h4 style={{ marginBottom: '10px', marginTop: '10px' }}>
          Adi syon içerisinde not bulunuyor. Yazdırma işlemi sırasında gözükmesini ister misiniz?
        </h4>
      </AlertDialog>
      <AlertDialog
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <span
              style={{
                width: "120%",
                marginTop: "15px",
              }}
            >
              Yazdır Önizle
            </span>
          </div>
        }
        open={print_dialog}
        closeHandler={() => setPrintDialog(false)}
        fullWidth
        maxWidth="md"
        printButtons={[
          {
            title: context.t(`receipt.create.printButtonTitle`),
            icon: "check",
            backgroundColor: "green",
            style: {
              height: "56px",
            },
            textColor: "white",
            content: () => printRef.current,
            onAfterPrint: () => setPrintDialog(false),
            trigger: () => { },
          }
        ]}
        buttons={[
          {
            title: context.t(`appointments.create.discardButtonTitle`),
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setPrintDialog(false),
          },
        ]}
      >
        <div ref={printRef}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              padding: "0px 70px",
            }}
          >
            <h2
              style={{
                margin: "40px",
                width: "100%",
                textAlign: "center",
              }}
            >
              {context.state.company_branch_first.name}
            </h2>
            <div
              style={{
                borderBottom: "2px solid #b2b2b2",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "33%", textAlign: "center" }}>
                {context.t(`["receipt/detail/id"].headingTitles.receiptId`)} {checkout_data?.receipt_id}
              </p>
              <p style={{ width: "33%", textAlign: "center" }}>
                {customer.full_name}
              </p>
              <p style={{ width: "33%", textAlign: "center" }}>
                {moment().format("DD-MM-YYYY")}
              </p>
            </div>
            {/* Hizmetler */}
            {(Object.keys(checkout_data?.services)?.filter(
              (key) => checkout_data?.services[key] !== undefined
            )?.length > 0 ||
              Object.keys(checkout_data?.packages)?.filter(
                (key) => checkout_data?.packages[key] !== undefined
              )?.length > 0) && (
                <>
                  <div style={{ width: "100%" }}>
                    <h3 style={{ paddingLeft: "20px", paddingTop: "10px" }}>
                      {context.t(`["receipt/detail/id"].headingTitles.services`)}
                    </h3>
                  </div>

                  <div
                    style={{
                      borderBottom: "1px solid #b2b2b2",
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.staff`)}</h4>
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.service`)}</h4>
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.amount`)}</h4>
                  </div>
                </>
              )}
            {Object.keys(checkout_data?.services).filter(
              (key) => checkout_data?.services[key] !== undefined
            ).length > 0 &&
              Object.keys(checkout_data?.services)?.map(
                (key, index) =>
                  checkout_data?.services[key] !== undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                      }}
                      key={index}
                    >
                      {/* Çalışan */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {
                          staffs?.filter(
                            (item) =>
                              item.id === checkout_data?.services[key]?.staff_id
                          )[0]?.full_name
                        }
                      </p>
                      {/* Hizmet */}

                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {
                          services?.filter(
                            (item) =>
                              item.id === checkout_data?.services[key]?.service_id
                          )[0]?.name
                        }
                      </p>
                      {/* Ücret */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {checkout_data?.services[key]?.amount}
                        {context.state?.currency ? context.state.currency : "₺"}
                      </p>
                    </div>
                  )
              )}
            {/* Paket Hizmetleri */}
            {Object.keys(checkout_data?.packages).filter(
              (key) => checkout_data?.packages[key] !== undefined
            ).length > 0 &&
              Object.keys(checkout_data?.packages)?.map(
                (key, index) =>
                  checkout_data?.packages[key] !== undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                      }}
                      key={index}
                    >
                      {/* Çalışan */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {
                          staffs?.filter(
                            (item) =>
                              item?.id === checkout_data?.packages[key]?.staff_id
                          )[0]?.full_name
                        }
                      </p>

                      {/* Hizmet */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {
                          services?.filter(
                            (item) =>
                              item?.id === checkout_data?.packages[key]?.service_id
                          )[0]?.name
                        }
                      </p>

                      {/* Ücret */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {checkout_data?.packages[key]?.amount}
                        {context.state.currency ? context.state.currency : "₺"}
                      </p>
                    </div>
                  )
              )}
            {/* Ürünler */}
            {Object.keys(checkout_data?.sales)?.filter(
              (key) => checkout_data?.sales[key] !== undefined
            )?.length > 0 && (
                <>
                  <div style={{ width: "100%" }}>
                    <h3 style={{ paddingLeft: "20px", paddingTop: "10px" }}>
                      {context.t(`["receipt/detail/id"].headingTitles.products`)}
                    </h3>
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid #b2b2b2",
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.product`)}</h4>
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.quantity`)}</h4>
                    <h4>{context.t(`["receipt/detail/id"].headingTitles.amount`)}</h4>
                  </div>
                </>
              )}
            {Object.keys(checkout_data?.sales)?.filter(
              (key) => checkout_data.sales[key] !== undefined
            )?.length > 0 &&
              Object.keys(checkout_data?.sales)?.map(
                (key, index) =>
                  checkout_data?.sales[key] !== undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                      }}
                      key={index}
                    >
                      {/* Ürün */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {
                          stock_items?.filter(
                            (item) =>
                              item?.id === checkout_data?.sales[key]?.stock_item_id
                          )[0]?.name
                        }
                      </p>

                      {/* Adet */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {checkout_data?.sales[key]?.quantity}
                      </p>

                      {/* Ücret */}
                      <p
                        style={{
                          width: "33%",
                          textAlign: "center",
                        }}
                      >
                        {checkout_data?.sales[key]?.amount}
                        {context.state.currency ? context.state.currency : "₺"}
                      </p>
                    </div>
                  )
              )}
            {/* Adisyon Özeti */}
            <div
              style={{
                width: "100%",
                marginTop: "40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              {/* Adisyon Toplamı */}
              <div
                className="mt-2"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {context.t(`["receipt/detail/id"].headingTitles.receiptTotalAmount`)}
                </span>
                <p>
                  {/* İndirim olmadan önceki orijinal toplam fiyat - Eğer checkout_data?.original_amount null ise hesapla */}
                  {(() => {
                    // Toplam hizmet tutarlarını hesapla
                    const servicesTotal = Object.keys(checkout_data?.services || {})
                      .map(key => {
                        const service = checkout_data?.services[key];
                        return service?.first_amount || service?.amount || 0;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    // Paket tutarlarını hesapla
                    const packagesTotal = Object.keys(checkout_data?.packages || {})
                      .map(key => {
                        const pkg = checkout_data?.packages[key];
                        return pkg?.first_amount || pkg?.amount || 0;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    // Ürün satış tutarlarını hesapla
                    const salesTotal = Object.keys(checkout_data?.sales || {})
                      .map(key => {
                        const sale = checkout_data?.sales[key];
                        const amount = sale?.first_amount || sale?.amount || 0;
                        const quantity = sale?.quantity || 1;
                        return parseFloat(amount) * quantity;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    // Genel toplam
                    const originalTotal = servicesTotal + packagesTotal + salesTotal;

                    return (checkout_data?.original_amount || originalTotal).toFixed(0);
                  })()}
                  {context.state.currency ? context.state.currency : "₺"}
                </p>
              </div>

              {/* İndirim Tutarı */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {context.t(`["receipt/detail/id"].headingTitles.discount`)}
                </span>
                <p>
                  {/* İndirim tutarını hesapla: Adisyon Toplamı - Net Toplam */}
                  {(() => {
                    // Adisyon toplamını hesapla
                    const servicesTotal = Object.keys(checkout_data?.services || {})
                      .map(key => {
                        const service = checkout_data?.services[key];
                        return service?.first_amount || service?.amount || 0;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    const packagesTotal = Object.keys(checkout_data?.packages || {})
                      .map(key => {
                        const pkg = checkout_data?.packages[key];
                        return pkg?.first_amount || pkg?.amount || 0;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    const salesTotal = Object.keys(checkout_data?.sales || {})
                      .map(key => {
                        const sale = checkout_data?.sales[key];
                        const amount = sale?.first_amount || sale?.amount || 0;
                        const quantity = sale?.quantity || 1;
                        return parseFloat(amount) * quantity;
                      })
                      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);

                    const originalTotal = checkout_data?.original_amount || (servicesTotal + packagesTotal + salesTotal);

                    // Net toplam
                    const netTotal = Object.keys(checkout_data?.services || {})
                      .map(key => parseFloat(checkout_data?.services[key]?.amount || 0))
                      .reduce((sum, amount) => sum + amount, 0) +
                      Object.keys(checkout_data?.packages || {})
                        .map(key => parseFloat(checkout_data?.packages[key]?.amount || 0))
                        .reduce((sum, amount) => sum + amount, 0) +
                      Object.keys(checkout_data?.sales || {})
                        .map(key => {
                          const sale = checkout_data?.sales[key];
                          return parseFloat(sale?.amount || 0) * (sale?.quantity || 1);
                        })
                        .reduce((sum, amount) => sum + amount, 0);

                    // checkout_data.total_amount kullanılabilirse kullan, yoksa hesaplanmış net toplam
                    const finalNetTotal = checkout_data?.total_amount || netTotal;

                    // İndirim = Adisyon Toplamı - Net Toplam
                    const discount = parseFloat(originalTotal) - parseFloat(finalNetTotal);

                    return Math.max(0, discount).toFixed(0);
                  })()}
                  {context.state.currency ? context.state.currency : "₺"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {context.t(`["receipt/detail/id"].headingTitles.netTotal`)}
                </span>
                <p>
                  {/* Adisyon toplam tutarı düzelt */}
                  {checkout_data?.total_amount ? checkout_data.total_amount.toFixed(0) : (
                    Object?.keys(checkout_data?.packages)
                      ?.map((key) => checkout_data?.packages[key]?.amount)
                      ?.reduce((acc, cur) => acc + cur, 0) +
                    Object?.keys(checkout_data?.services)
                      ?.map((key) => checkout_data?.services[key]?.amount)
                      ?.reduce((acc, cur) => acc + cur, 0) +
                    Object?.keys(checkout_data?.sales)
                      ?.map(
                        (key) =>
                          checkout_data?.sales[key]?.amount *
                          checkout_data?.sales[key]?.quantity
                      )
                      ?.reduce((acc, cur) => acc + cur, 0)
                  ).toFixed(0)}
                  {context.state.currency ? context.state.currency : "₺"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {context.t(`["receipt/detail/id"].headingTitles.paidAmount`)}
                </span>
                <p>
                  {/* Ödenen tutarı düzelt - getTotalAmounts().paids kullan */}
                  {parseFloat(getTotalAmounts()?.paids || 0).toFixed(0)}
                  {context.state.currency ? context.state.currency : "₺"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: "20px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {context.t(`["receipt/detail/id"].headingTitles.remaintAmount`)}
                </span>
                <p>
                  {/* Kalan tutarı düzelt - (Net Toplam - Ödenen Tutar) */}
                  {(checkout_data?.total_amount
                    ? checkout_data.total_amount
                    : (Object?.keys(checkout_data?.packages)
                      ?.map((key) => checkout_data?.packages[key]?.amount)
                      ?.reduce((acc, cur) => acc + cur, 0) +
                      Object?.keys(checkout_data?.services)
                        ?.map((key) => checkout_data?.services[key]?.amount)
                        ?.reduce((acc, cur) => acc + cur, 0) +
                      Object?.keys(checkout_data?.sales)
                        ?.map(
                          (key) =>
                            checkout_data?.sales[key]?.amount *
                            checkout_data?.sales[key]?.quantity
                        )
                        ?.reduce((acc, cur) => acc + cur, 0))
                  ) - parseFloat(getTotalAmounts()?.paids || 0)}
                  {context.state.currency ? context.state.currency : "₺"}
                </p>
              </div>
              {
                noteSelected && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginLeft: "20px",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        marginRight: "5px",
                      }}
                    >
                      Not :
                    </span>
                    <p>
                      {receipt_note}
                    </p>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </AlertDialog>
      <Column className="xs-12 sm-12 md-4 lg-6">
        <Column className="xs-12 sm-12 md-4 lg-3 mb-3">
          <ReceiptProfile
            style={{
              cursor: "pointer",
              border: `1px solid ${sex === 0 ? "#8c0fb4" : "#3189ec"}`,
              backgroundColor: `${sex === 0 ? "rgba(140,15,180, 0.1)" : "rgba(49,137,236,0.08)"
                }`,
            }}
            onClick={() => history.push(`/customers/detail/${customer?.id}`)}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Person
                style={{
                  marginRight: "5px",
                  color: `${sex === 0 ? "#8c0fb4" : "#3189ec"}`,
                }}
              />
              <div
                style={{
                  marginTop: "5px",
                  fontSize: `${customer?.full_name?.length > 15 ? "8px" : "12px"
                    }`,
                }}
              >
                {customer?.full_name || "Tanımlanmamış Müşteri"}
              </div>
            </div>
            <div>
              <Phone style={{ marginRight: "5px", color: "#b2b2b2" }} />
              <>{customer?.phone || null}</>
            </div>
          </ReceiptProfile>
        </Column>

        <Column className="xs-12 sm-12 md-4 lg-3">
          <Button
            icon="print"
            fullWidth
            size="lg"
            title={
              process.env.APP_NAME === "management" ? "Print" : "Yazdır"
            }
            onClick={() => {
              if (receipt_note === '' || receipt_note === null || receipt_note === undefined) {
                setPrintDialog(!print_dialog)
              } else {
                setNoteDialog(true)
              }
            }}
            backgroundColor="teal-opacity"
            textColor="teal"
            outlined={true}
          />
        </Column>

        <Column className="xs-12 sm-12 md-4 lg-3">
          <Button
            icon="contacts"
            fullWidth
            size="lg"
            outlined={true}
            title={
              process.env.APP_NAME === "management" ? "Agreement" : "Sözleşme"
            }
            backgroundColor="orange-opacity"
            textColor="orange"
            onClick={() => {
              //
              if (context.state.company_license.accounting === 3) {
                if (is_change) {
                  toast.warning(
                    context.t(`["receipt/detail/id"].agreementSaveButtonWarnToast1`)
                  );
                } else {
                  setContractDialog(true);
                  getAgreements();
                  getClauses();
                }
              } else {
                toast.warn(
                  context.t(`["receipt/detail/id"].agreementSaveButtonWarnToast2`)
                );
              }
            }}
          />
        </Column>

        <Column className="xs-12 sm-12 md-4 lg-3">
          <CustomerBoxDiv
            style={{
              border: "1px solid #3189ec",
              backgroundColor: "rgba(49,137,236,0.08)",
            }}
          >
            <img
              src={CustomerPoint}
              alt="customer_point"
              style={{ height: "70%" }}
            />
            <CustomerPointBox>
              <span>
                {customer?.point !== null && customer?.point !== undefined
                  ? `${customer?.point}`
                  : "0"}{" "}
                {context.t(`['receipt/detail/id'].point`)}
                <b>
                  ~
                  {customer?.point !== null && customer?.point !== undefined
                    ? `${customer?.point / 100}`
                    : "0"}
                  {context.state.currency ? context.state.currency : "₺"}
                </b>
              </span>
              {/* <h3>{context.t(`['receipt/detail/id'].customerPoint`)}</h3> */}
            </CustomerPointBox>
          </CustomerBoxDiv>
        </Column>
      </Column>

      <Column className="xs-12 sm-12 md-4 lg-6">
        <Column
          className={
            process.env.APP_NAME !== "management"
              ? "xs-12 sm-12 md-12 lg-3"
              : "xs-12 sm-12 md-12 lg-4"
          }
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PaymentSection
            style={{
              backgroundColor: "rgb(255, 144, 22, 0.14)",
              border: "1px solid #ff9016",
            }}
          >
            <img src={ReceiptOrange} alt="receipt" />
            <SubTotalText
              style={{
                color: "#ff9016",
              }}
            >
              <p
                style={{
                  fontSize: "17px",
                  fontWeight: "400",
                }}
              >
                {getAllTotalService().toFixed(0)}
                {context.state.currency
                  ? context.state.currency
                  : "₺"}
              </p>
              <span>
                {context.t(`['receipt/detail/id'].payments.totalAmount`)}
              </span>
            </SubTotalText>
          </PaymentSection>
        </Column>

        <Column
          className={
            process.env.APP_NAME !== "management"
              ? "xs-12 sm-12 md-12 lg-3"
              : "xs-12 sm-12 md-12 lg-4"
          }
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PaymentSection
            style={{
              backgroundColor: "rgb(29, 139, 62, 0.21)",
              border: "1px solid rgb(58, 154, 87, 0.35)",
            }}
          >
            <img src={PaymentGreen} alt="payment" />
            <SubTotalText
              style={{
                color: "#1D8B3E",
              }}
            >
              <p
                style={{
                  fontSize: "17px",
                  fontWeight: "400",
                }}
              >
                {parseFloat(
                  getTotalAmounts()?.installment_total +
                  getTotalAmounts()?.paids
                )}
                {context.state.currency
                  ? context.state.currency
                  : "₺"}
              </p>
              <span>
                {context.t(
                  `['receipt/detail/id'].payments.totalPaidAmount`
                )}
              </span>
            </SubTotalText>
          </PaymentSection>
        </Column>

        <Column
          className={
            process.env.APP_NAME !== "management"
              ? "xs-12 sm-12 md-12 lg-3"
              : "xs-12 sm-12 md-12 lg-4"
          }
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PaymentSection
            style={{
              backgroundColor: "rgb(254, 151, 151, 0.19)",
              border: "1px solid rgb(185, 178, 178, 0.65)",
            }}
          >
            <img src={Debt} alt="debt" />
            <SubTotalText
              style={{
                color: `${parseFloat(getAllTotalService()).toFixed(0) -
                  parseFloat(
                    (getTotalAmounts()?.installment_total +
                      getTotalAmounts()?.paids)
                  ).toFixed(0) >
                  0
                  ? "#FC8E8E"
                  : "grey"
                  }`,
              }}
            >
              <p
                style={{
                  fontSize: "17px",
                  fontWeight: "400",
                }}
              >
                {parseFloat(getAllTotalService())?.toFixed(0) -
                  parseFloat(
                    (getTotalAmounts()?.installment_total +
                      getTotalAmounts()?.paids)
                  ).toFixed(0)}
                {context.state.currency
                  ? context.state.currency
                  : "₺"}
              </p>
              <span>
                {context.t(
                  `['receipt/detail/id'].payments.totalDebtAmount`
                )}
              </span>
            </SubTotalText>
          </PaymentSection>
        </Column>
        {process.env.APP_NAME !== "management" && (
          <Column
            className="xs-12 sm-12 md-12 lg-3"
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PaymentSection
              style={{
                backgroundColor: "rgba(49,137,236,0.08)",
                border: "1px solid rgb(185, 178, 178, 0.65)",
              }}
            >
              <Button
                icon="storage"
                size="lg"
                title={context.t(`["receipt/detail/id"].routeToLogs`)}
                onClick={() => {
                  context.dispatch({
                    type: "LOG_TYPE",
                    payload: { log_type: 2 },
                  });
                  context.dispatch({
                    type: "LOG_ID",
                    payload: {
                      log_id: Number(checkout_data?.receipt_id),
                    },
                  });
                  history.push("/settings/logs");
                }}
              />
            </PaymentSection>
          </Column>
        )}
      </Column>

      {/* Sözleşme için açılan pop-up */}
      <AlertDialog
        title={""}
        open={contract_dialog}
        maxWidth={contract_tab === 3 || file ? "md" : "sm"}
        fullWidth
        disableBackdropClick={false}
        closeHandler={() => {
          setContractDialog(false);
          setContractInfoIdNumber("");
          setContractInfoTaxNumber("");
          setContractInfoAddress("");
        }}
      >
        {contract_tab !== 0 && (
          <ArrowBackIosIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              setContractTab(0);
              setSelectedPattern({
                Clauses: [],
                Template: [],
              });
              setNewAgreementDetail(false);
              setFile(null);
            }}
          />
        )}
        {contract_tab === 0 && (
          <ContractDialogEntrance
            setContractTab={setContractTab}
            getCustomerAgreements={getCustomerAgreements}
            checkout_data={checkout_data}
          />
        )}
        {contract_tab === 1 && (
          <ContractDialogCreateNewContract
            checkout_data={checkout_data}
            contract_patterns={contract_patterns}
            selected_pattern={selected_pattern}
            setSelectedPattern={setSelectedPattern}
            setNewAgreementDetail={setNewAgreementDetail}
            selected_agreement_dialog_show={selected_agreement_dialog_show}
            setSelectedAgreementDialogShow={setSelectedAgreementDialogShow}
            newAgreementDetail={newAgreementDetail}
            setAgreementDetail={setAgreementDetail}
            contract_info_ful_name={contract_info_ful_name}
            setContractInfoFulName={setContractInfoFulName}
            contract_info_phone={contract_info_phone}
            setContractInfoPhone={setContractInfoPhone}
            contract_info_id_number={contract_info_id_number}
            setContractInfoIdNumber={setContractInfoIdNumber}
            contract_info_tax_number={contract_info_tax_number}
            setContractInfoTaxNumber={setContractInfoTaxNumber}
            contract_info_address={contract_info_address}
            setContractInfoAddress={setContractInfoAddress}
            contract_patterns_wo_clauses={contract_patterns_wo_clauses}
            logo_src={logo_src}
            staffArr={staffArr}
            servicesArr={servicesArr}
            getAllTotalService={getAllTotalService}
            clauses={clauses}
            Signature={Signature}
            content_to_signiture={content_to_signiture}
            setContentToSigniture={setContentToSigniture}
            send_to_signiture_aproval_modal={send_to_signiture_aproval_modal}
            setSendToSignitureAprovalModal={setSendToSignitureAprovalModal}
            sendAgreementToMobile={sendAgreementToMobile}
          />
        )}
        {contract_tab === 2 && (
          <ContractDialogUploadContract
            file={file}
            setFile={setFile}
            agreement_customer_for_receipt={agreement_customer_for_receipt}
            setAgreementCustomerForReceipt={setAgreementCustomerForReceipt}
            agreement_title={agreement_title}
            setAgreementTitle={setAgreementTitle}
            uploadAgreement={uploadAgreement}
          />
        )}
        {contract_tab === 3 && (
          <ContractDialogContracts
            customer_agreements={customer_agreements}
            agreement_load={agreement_load}
            pagination_agreement={pagination_agreement}
            wp_aproval_modal={wp_aproval_modal}
            setWpAprovalModal={setWpAprovalModal}
            send_wp_id={send_wp_id}
            setSendWpId={setSendWpId}
            send_wp_customer_name={send_wp_customer_name}
            setSendWpCustomerName={setSendWpCustomerName}
            send_wp_agreement_name={send_wp_agreement_name}
            setSendWpAgreementName={setSendWpAgreementName}
            sms_aproval_modal={sms_aproval_modal}
            setSmsAprovalModal={setSmsAprovalModal}
            send_sms_id={send_sms_id}
            setSendSmsId={setSendSmsId}
            send_sms_customer_name={send_sms_customer_name}
            setSendSmsCustomerName={setSendSmsCustomerName}
            send_sms_agreement_name={send_sms_agreement_name}
            setSendSmsAgreementName={setSendSmsAgreementName}
            delete_agreement_dialog={delete_agreement_dialog}
            setDeleteAgreementDialog={setDeleteAgreementDialog}
            sendSMSAgreement={sendSMSAgreement}
            sendWPAgreement={sendWPAgreement}
            agreement_delete_id={agreement_delete_id}
            setAgreementDeleteId={setAgreementDeleteId}
            deleteAgreement={deleteAgreement}
          />
        )}

        {newAgreementDetail ? (
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <div
              style={{
                width: "35%",
              }}
            >
              <Button
                fullWidth
                title={context.t(`["receipt/detail/id"].previewTitle`)}
                textColor="white"
                backgroundColor="orange"
                onClick={() => {
                  if (
                    selected_pattern?.Template?.nationality_id &&
                    contract_info_id_number !== "" &&
                    !validateTCKN(contract_info_id_number)
                  ) {
                    toast.error(context.t(`["receipt/detail/id"].previewErrorToast`));
                  } else {
                    setSelectedAgreementDialogShow(true);
                    getServices();
                    getStaff();
                  }
                }}
              />
            </div>
            <div
              style={{
                width: "35%",
              }}
            >
              <Button
                fullWidth
                outlined
                icon="clear"
                title={contract_tab === 3 ? "Kapat" : "İptal"}
                textColor="#ccc"
                onClick={() => {
                  setContractDialog(false);
                  setTimeout(() => {
                    setContractTab(0);
                    setSelectedPattern({
                      Clauses: [],
                      Template: [],
                    });
                    setNewAgreementDetail(false);
                    setContractInfoTaxNumber("");
                    setContractInfoAddress("");
                    setFile(null);
                    setAgreementTitle("");
                  }, 500);
                }}
              />
            </div>{" "}
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "35%" }}>
              <Button
                title={contract_tab === 3 ? context.t(`sms.buttonApprove`) : context.t(`["receipt/detail/id"].sms.discardButtonTitle`)}
                fullWidth
                outlined
                icon="clear"
                textColor="#ccc"
                onClick={() => {
                  setContractDialog(false);
                  setTimeout(() => {
                    setContractTab(0);
                    setSelectedPattern({
                      Clauses: [],
                      Template: [],
                    });
                    setNewAgreementDetail(false);
                    setContractInfoTaxNumber("");
                    setContractInfoAddress("");
                  }, 500);
                }}
              />
            </div>
          </div>
        )}
      </AlertDialog>
    </Grid>
  );
};

/**
 * Adisyona ödeme yöntemlerinin eklendiği, düzenlendiği alan.
 */
export const _PaymentsBuilder = ({
  checkout_data,
  setCheckoutData,
  advanced_date,
  advanced_amount,
  advanced_staff,
  selected_installment,
  setSelectedInstallment,
  setSelectedInstallmentStatus,
  advanced_type,
  installment_date,
  setInstallmentDate,
  installment_data,
  setPaymentDetailDialogModal,
  setAddPaymentDialog,
  addPayment_dialog,
  setAdvancedAmount,
  setIsChange,
  is_change,
  getPaidsDiffTotal,
  setAdvancedDate,
  setAdvancedType,
  setAdvancedStaff,
  setPaymentSelectStaff,
  staffs,
  payment_select_staff,
  setInstallmentDialog,
  installment_dialog,
  getAllTotalService,
  setSaveButtonDisabled,
  saveSingleReceipt,
  singlePaymentAndInstallmentPayment,
  deleteSingleReceiptPayment,
  services,
  packages,
  stockItems,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  lastSaveTimestamp,
  setLastSaveTimestamp
}) => {
  const context = useContext(AppContext);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedItem, setSelectedItem] = useState({ value: null, type: null });
  const [pendingUpdate, setPendingUpdate] = useState(null);
  const [pendingPaymentUpdate, setPendingPaymentUpdate] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [selectedDetailAdvanced, setSelectedDetailAdvanced] = useState(null);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [saveDialogOpenInstallment, setSaveDialogOpenInstallment] = useState(false);

  // Component unmount olurken dialog'ları kapat
  useEffect(() => {
    return () => {
      setSaveDialogOpen(false);
      setSaveDialogOpenInstallment(false);
    };
  }, []);
  const [expandedMatch, setExpandedMatch] = useState(null);
  const [expandedInstallmentMatch, setExpandedInstallmentMatch] = useState(null);
  const currency = context.state.currency || "₺";
  let total_mount = 0;

  // Tutar giriş alanları için state'ler
  const [inputValues, setInputValues] = useState({});
  const [installmentInputValues, setInstallmentInputValues] = useState({});
  const [paymentDetailValue, setPaymentDetailValue] = useState({});
  const [installmentDetailValue, setInstallmentDetailValue] = useState({});
  const [newPaymentValue, setNewPaymentValue] = useState("");

  // Ödemeleri match değerine göre gruplama
  const getGroupedPayments = useCallback(() => {
    if (!checkout_data || !checkout_data.paids) return [];

    console.log("Tüm ödemeler:", Object.values(checkout_data.paids).filter(p => p !== undefined));

    // Pozitif match değerine sahip ödemeleri grupla
    const positiveMatchGroups = {};
    // Match değeri 0 veya olmayan ödemeleri ayrı tut
    const zeroOrNullMatchPayments = [];

    Object.values(checkout_data.paids)
      .filter(payment => payment !== undefined)
      .forEach(payment => {
        // Match değerini kontrol et
        console.log(`Ödeme ID: ${payment.id}, Match değeri:`, payment.match);

        // Payment nesnesini klonla ve gerekli dönüşümleri yap
        const normalizedPayment = { ...payment };

        // payment_type değerini Number'a dönüştür
        if (normalizedPayment.payment_type !== undefined) {
          normalizedPayment.payment_type = Number(normalizedPayment.payment_type);
        }

        // pay_amount değerini Number'a dönüştür ve 2 ondalık basamağa yuvarla
        if (normalizedPayment.pay_amount !== undefined) {
          normalizedPayment.pay_amount = Math.round(parseFloat(normalizedPayment.pay_amount) * 100) / 100;
        }

        // Match değeri pozitif bir sayı ise gruplanacak
        if (normalizedPayment.match && typeof normalizedPayment.match === 'number' && normalizedPayment.match > 0) {
          if (!positiveMatchGroups[normalizedPayment.match]) {
            positiveMatchGroups[normalizedPayment.match] = [];
          }
          positiveMatchGroups[normalizedPayment.match].push(normalizedPayment);
        }
        // Match değeri 0, null veya undefined ise ayrı göster
        else {
          zeroOrNullMatchPayments.push(normalizedPayment);
        }
      });

    // Pozitif match değerli grupları oluştur
    const groupedResults = Object.entries(positiveMatchGroups).map(([matchValue, payments]) => {
      const totalAmount = payments.reduce((sum, payment) => sum + parseFloat(payment.pay_amount || 0), 0);
      return {
        matchId: parseInt(matchValue),
        payments,
        payment_date: payments[0].payment_date,
        payment_type: Number(payments[0].payment_type),
        staff_id: payments[0].staff_id,
        total_amount: totalAmount,
        payment_count: payments.length,
        isGroup: payments.length > 1
      };
    });

    // Match değeri 0, null veya undefined olan ödemeleri ekle
    const individualResults = zeroOrNullMatchPayments.map(payment => {
      return {
        matchId: payment.id, // Match değeri olmadığı için ID'yi kullan
        payments: [payment],
        payment_date: payment.payment_date,
        payment_type: Number(payment.payment_type),
        staff_id: payment.staff_id,
        total_amount: parseFloat(payment.pay_amount || 0),
        payment_count: 1,
        isGroup: false
      };
    });

    // Tüm sonuçları birleştir
    const allResults = [...groupedResults, ...individualResults];
    console.log("Gruplandırılmış ödemeler:", allResults);

    return allResults;
  }, [checkout_data]);

  // Taksitleri match değerine göre gruplama
  const getGroupedInstallments = useCallback(() => {
    if (!checkout_data || !checkout_data.installment) return [];

    console.log("Tüm taksitler:", Object.values(checkout_data.installment).filter(i => i !== undefined));

    // Pozitif match değerine sahip taksitleri grupla
    const positiveMatchGroups = {};
    // Match değeri 0 veya olmayan taksitleri ayrı tut
    const zeroOrNullMatchInstallments = [];

    Object.values(checkout_data.installment)
      .filter(installment => installment !== undefined)
      .forEach(installment => {
        // Match değerini kontrol et
        console.log(`Taksit ID: ${installment.id}, Match değeri:`, installment.match);

        // Installment nesnesini klonla ve gerekli dönüşümleri yap
        const normalizedInstallment = { ...installment };

        // installment_type değerini Number'a dönüştür
        if (normalizedInstallment.installment_type !== undefined) {
          normalizedInstallment.installment_type = Number(normalizedInstallment.installment_type);
        }

        // installment_amount değerini Number'a dönüştür ve 2 ondalık basamağa yuvarla
        if (normalizedInstallment.installment_amount !== undefined) {
          normalizedInstallment.installment_amount = Math.round(parseFloat(normalizedInstallment.installment_amount) * 100) / 100;
        }

        // Match değeri pozitif bir sayı ise gruplanacak
        if (normalizedInstallment.match && typeof normalizedInstallment.match === 'number' && normalizedInstallment.match > 0) {
          if (!positiveMatchGroups[normalizedInstallment.match]) {
            positiveMatchGroups[normalizedInstallment.match] = [];
          }
          positiveMatchGroups[normalizedInstallment.match].push(normalizedInstallment);
        }
        // Match değeri 0, null veya undefined ise ayrı göster
        else {
          zeroOrNullMatchInstallments.push(normalizedInstallment);
        }
      });

    // Pozitif match değerli grupları oluştur
    const groupedResults = Object.entries(positiveMatchGroups).map(([matchValue, installments]) => {
      const totalAmount = installments.reduce((sum, installment) => sum + parseFloat(installment.installment_amount || 0), 0);

      // Grup durumunu hesapla
      let groupStatus = 0; // Varsayılan olarak bekliyor
      const hasPaid = installments.some(i => i.installment_status === 1);
      const hasNotPaid = installments.some(i => i.installment_status === 2);

      if (hasPaid && !hasNotPaid) {
        groupStatus = 1; // Tümü ödendi
      } else if (hasNotPaid) {
        groupStatus = 2; // En az biri ödenmedi
      }

      return {
        matchId: parseInt(matchValue),
        installments,
        installment_date: installments[0].installment_date,
        installment_type: Number(installments[0].installment_type),
        installment_staff: installments[0].installment_staff,
        installment_status: groupStatus,
        total_amount: totalAmount,
        installment_count: installments.length,
        isGroup: installments.length > 1
      };
    });

    // Match değeri 0, null veya undefined olan taksitleri ekle
    const individualResults = zeroOrNullMatchInstallments.map(installment => {
      return {
        matchId: installment.id, // Match değeri olmadığı için ID'yi kullan
        installments: [installment],
        installment_date: installment.installment_date,
        installment_type: Number(installment.installment_type),
        installment_staff: installment.installment_staff,
        installment_status: installment.installment_status,
        total_amount: parseFloat(installment.installment_amount || 0),
        installment_count: 1,
        isGroup: false
      };
    });

    // Tüm sonuçları birleştir
    const allResults = [...groupedResults, ...individualResults];
    console.log("Gruplandırılmış taksitler:", allResults);

    return allResults;
  }, [checkout_data]);

  // Grupları hesapla
  const groupedPayments = getGroupedPayments();
  const groupedInstallments = getGroupedInstallments();

  // Function to handle installment changes
  const handleInstallmentChange = useCallback((installmentId, updatedData) => {
    if (!checkout_data || !updatedData) return;

    // Güncellenecek taksiti bul
    const installmentKey = Object.keys(checkout_data.installment || {}).find(
      key => checkout_data.installment[key]?.id === installmentId
    );

    if (!installmentKey || !checkout_data.installment[installmentKey]) {
      console.warn("Geçersiz taksit anahtarı veya veri");
      return;
    }

    const installment = checkout_data.installment[installmentKey];

    // Sadece taksit durumu güncelleniyorsa
    if ('installment_status' in updatedData) {
      const updatedInstallment = {
        ...installment,
        installment_status: updatedData.installment_status
      };

      const updatedCheckoutData = {
        ...checkout_data,
        installment: {
          ...checkout_data.installment,
          [installmentKey]: updatedInstallment
        }
      };

      setCheckoutData(updatedCheckoutData);

      // API çağrısını hemen yap
      singlePaymentAndInstallmentPayment({
        receipt_id: parseInt(checkout_data?.receipt_id),
        id: parseInt(installmentId),
        receipt_type: 1,
        is_installment: true,
        payments: [{
          payment_id: parseInt(installmentId),
          payment_date: moment(installment.installment_date).toISOString(),
          payment_type: Number(installment.installment_type),
          staff_id: parseInt(installment.installment_staff),
          amount: parseFloat(installment.installment_amount),
          payment_status: updatedData.installment_status,
          sale_id: installment.sale_id,
          sale_type: installment.sale_type
        }]
      });
      return;
    }

    // Miktar değişikliği için grup güncellemesi
    if (installment.match && installment.match > 0 && 'installment_amount' in updatedData) {
      // Aynı match değerine sahip tüm taksitleri bul
      const matchedInstallmentKeys = Object.keys(checkout_data.installment || {})
        .filter(key =>
          checkout_data.installment[key]?.match === installment.match &&
          checkout_data.installment[key] !== undefined
        );

      // Eğer birden fazla eşleşen taksit varsa, grup güncellemesi yap
      if (matchedInstallmentKeys.length > 1) {
        // Yeni toplam tutar - bu değer direkt kullanıcının girdiği değerdir
        const exactTotalAmount = parseInt(updatedData.installment_amount || 0);

        // Güncellenmiş checkout verisi
        let updatedCheckoutData = { ...checkout_data };
        // API için taksit verileri
        let updatedInstallments = [];

        // Mevcut toplam tutarı hesapla
        const totalOriginalAmount = matchedInstallmentKeys.reduce(
          (sum, key) => sum + parseFloat(checkout_data.installment[key]?.installment_amount || 0),
          0
        );

        // Toplam tutardaki farkı hesapla
        const amountDifference = exactTotalAmount - totalOriginalAmount;

        // Tamamlanmış taksitleri değiştirmeden koru (son taksit hariç)
        let runningTotal = 0;

        // Taksitleri güncelle (son taksit hariç)
        for (let i = 0; i < matchedInstallmentKeys.length - 1; i++) {
          const key = matchedInstallmentKeys[i];
          const currentInstallment = checkout_data.installment[key];

          // Mevcut tutarı koru
          const currentAmount = parseFloat(currentInstallment.installment_amount || 0);
          runningTotal += currentAmount;

          // Taksit nesnesini güncelle (tutarı değiştirmeden)
          updatedCheckoutData.installment[key] = {
            ...currentInstallment,
            installment_amount: currentAmount
          };

          // API için taksit verisini hazırla
          updatedInstallments.push({
            payment_id: parseInt(currentInstallment.id),
            payment_date: updatedData.installment_date
              ? moment(updatedData.installment_date).toISOString()
              : moment(currentInstallment.installment_date).toISOString(),
            payment_type: updatedData.installment_type !== undefined
              ? Number(updatedData.installment_type)
              : Number(currentInstallment.installment_type),
            staff_id: updatedData.installment_staff !== undefined
              ? parseInt(updatedData.installment_staff)
              : parseInt(currentInstallment.installment_staff),
            amount: currentAmount,
            payment_status: updatedData.installment_status !== undefined
              ? updatedData.installment_status
              : currentInstallment.installment_status,
            sale_id: updatedData.sale_id !== undefined
              ? updatedData.sale_id
              : currentInstallment.sale_id,
            sale_type: updatedData.sale_type !== undefined
              ? updatedData.sale_type
              : currentInstallment.sale_type
          });
        }

        // Son taksiti hesapla - tüm değişikliği son taksite yansıt
        const lastKey = matchedInstallmentKeys[matchedInstallmentKeys.length - 1];
        const lastInstallment = checkout_data.installment[lastKey];

        // Son taksit tutarını, toplam değişimi ekleyerek hesapla
        const lastAmount = Math.max(0, exactTotalAmount - runningTotal);

        // Son taksiti güncelle
        updatedCheckoutData.installment[lastKey] = {
          ...lastInstallment,
          installment_amount: lastAmount
        };

        // Son taksiti API listesine ekle
        updatedInstallments.push({
          payment_id: parseInt(lastInstallment.id),
          payment_date: updatedData.installment_date
            ? moment(updatedData.installment_date).toISOString()
            : moment(lastInstallment.installment_date).toISOString(),
          payment_type: updatedData.installment_type !== undefined
            ? Number(updatedData.installment_type)
            : Number(lastInstallment.installment_type),
          staff_id: updatedData.installment_staff !== undefined
            ? parseInt(updatedData.installment_staff)
            : parseInt(lastInstallment.installment_staff),
          amount: lastAmount,
          payment_status: updatedData.installment_status !== undefined
            ? updatedData.installment_status
            : lastInstallment.installment_status,
          sale_id: updatedData.sale_id !== undefined
            ? updatedData.sale_id
            : lastInstallment.sale_id,
          sale_type: updatedData.sale_type !== undefined
            ? updatedData.sale_type
            : lastInstallment.sale_type
        });

        // State'i güncelle
        setCheckoutData(updatedCheckoutData);

        // API için çağrıyı hazırla
        if ('installment_amount' in updatedData) {
          setPendingUpdate({
            isGroup: true,
            matchId: installment.match,
            receipt_id: parseInt(checkout_data?.receipt_id),
            payments: updatedInstallments
          });
        } else {
          // Miktar değişmediyse hemen API çağrısını yap
          singlePaymentAndInstallmentPayment({
            receipt_id: parseInt(checkout_data?.receipt_id),
            id: parseInt(installmentId),
            receipt_type: 1,
            is_installment: true,
            payments: updatedInstallments
          });
        }

        return;
      }
    }

    // Tekil taksit güncellemesi
    const updatedInstallment = {
      ...installment,
      ...updatedData
    };

    // Checkout verilerini güncelle
    const updatedCheckoutData = {
      ...checkout_data,
      installment: {
        ...checkout_data.installment,
        [installmentKey]: updatedInstallment
      }
    };

    setCheckoutData(updatedCheckoutData);

    // Miktar güncellemesi için debounce kullan
    if ('installment_amount' in updatedData) {
      setPendingUpdate({
        installmentId,
        installmentKey,
        data: updatedData
      });
      return;
    }

    // Diğer değişiklikler için hemen API çağrısını yap
    const paymentData = {
      receipt_id: parseInt(checkout_data?.receipt_id),
      id: parseInt(installmentId),
      receipt_type: 1,
      is_installment: true,
      payments: [{
        payment_id: parseInt(installmentId),
        payment_date: updatedData.installment_date
          ? moment(updatedData.installment_date).toISOString()
          : moment(installment.installment_date).toISOString(),
        payment_type: updatedData.installment_type !== undefined
          ? Number(updatedData.installment_type)
          : Number(installment.installment_type),
        staff_id: updatedData.installment_staff !== undefined
          ? parseInt(updatedData.installment_staff)
          : parseInt(installment.installment_staff),
        amount: updatedData.installment_amount !== undefined
          ? parseFloat(updatedData.installment_amount)
          : parseFloat(installment.installment_amount),
        payment_status: updatedData.installment_status !== undefined
          ? updatedData.installment_status
          : installment.installment_status,
        sale_id: updatedData.sale_id !== undefined
          ? updatedData.sale_id
          : installment.sale_id,
        sale_type: updatedData.sale_type !== undefined
          ? updatedData.sale_type
          : installment.sale_type
      }]
    };

    singlePaymentAndInstallmentPayment(paymentData);
  }, [checkout_data, setCheckoutData, singlePaymentAndInstallmentPayment, setHasUnsavedChanges]);

  // Effect to handle debounced amount changes
  useEffect(() => {
    if (!pendingUpdate) return;

    const timer = setTimeout(() => {
      // Grup güncelleme (match değeri olan taksitler)
      if (pendingUpdate.isGroup) {
        const paymentData = {
          receipt_id: parseInt(checkout_data?.receipt_id),
          id: parseInt(pendingUpdate.matchId || 0),
          receipt_type: 1,
          is_installment: true,
          payments: pendingUpdate.payments
        };

        singlePaymentAndInstallmentPayment(paymentData);
      }
      // Tekil taksit güncellemesi
      else if (pendingUpdate.installmentId) {
        const installmentKey = pendingUpdate.installmentKey;
        const installment = checkout_data.installment[installmentKey];

        if (!installment) {
          console.warn("Taksit bulunamadı:", pendingUpdate.installmentId);
          setPendingUpdate(null);
          return;
        }

        const paymentData = {
          receipt_id: parseInt(checkout_data?.receipt_id),
          id: parseInt(pendingUpdate.installmentId),
          receipt_type: 1,
          is_installment: true,
          payments: [{
            payment_id: parseInt(pendingUpdate.installmentId),
            payment_date: pendingUpdate.data.installment_date
              ? moment(pendingUpdate.data.installment_date).toISOString()
              : moment(installment.installment_date || new Date()).toISOString(),
            payment_type: pendingUpdate.data.installment_type !== undefined
              ? Number(pendingUpdate.data.installment_type)
              : Number(installment.installment_type || 0),
            staff_id: pendingUpdate.data.installment_staff !== undefined
              ? parseInt(pendingUpdate.data.installment_staff)
              : parseInt(installment.installment_staff || 0),
            amount: pendingUpdate.data.installment_amount !== undefined
              ? parseFloat(pendingUpdate.data.installment_amount)
              : parseFloat(installment.installment_amount || 0),
            payment_status: pendingUpdate.data.installment_status !== undefined
              ? pendingUpdate.data.installment_status
              : installment.installment_status || 0,
            sale_id: pendingUpdate.data.sale_id !== undefined
              ? pendingUpdate.data.sale_id
              : installment.sale_id,
            sale_type: pendingUpdate.data.sale_type !== undefined
              ? pendingUpdate.data.sale_type
              : installment.sale_type
          }]
        };

        singlePaymentAndInstallmentPayment(paymentData);
      }

      setPendingUpdate(null);
    }, 750);

    return () => clearTimeout(timer);
  }, [pendingUpdate, checkout_data, singlePaymentAndInstallmentPayment]);

  const getInstallmentDiffTotal = (count) => {
    if (!checkout_data) return 0;
    if (!selectedItem || !selectedItem.value) {
      console.warn('getInstallmentDiffTotal - No item selected');
      return 0;
    }

    try {
      // If an item is selected, find its amount from the items array
      const items = [
        ...Object.values(checkout_data.services || {}).map(service => ({
          label: `Service ID: ${service.service_id}`,
          value: service.id,
          type: 'service',
          amount: service.amount
        })),
        ...Object.values(checkout_data.groupsAmount || {}).map(group => ({
          label: `Package ID: ${group.packet_id}`,
          value: group.id,
          type: 'package',
          amount: group.amount
        })),
        ...Object.values(checkout_data.packages || {}).map(pkg => ({
          label: `Package ID: ${pkg.service_id}`,
          value: pkg.id,
          type: 'package',
          amount: pkg.amount
        })),
        ...Object.values(checkout_data.sales || {}).map(sale => ({
          label: `Product ID: ${sale.stock_item_id}`,
          value: sale.id,
          type: 'sale',
          amount: sale.amount
        }))
      ];

      const selectedItemValue = parseInt(selectedItem.value);
      const selectedItemWithAmount = items.find(item => item.value === selectedItemValue);

      if (selectedItemWithAmount) {
        // Seçilen öğenin tutarını count'a bölelim. Count 0 ise direkt tutar döndürelim.
        return count > 0 ? selectedItemWithAmount.amount / count : selectedItemWithAmount.amount;
      }
      return 0;
    } catch (error) {
      console.error('getInstallmentDiffTotal - Error:', error);
      return 0;
    }
  };

  const getTotalAmounts = () => {
    const totalAmount = Object.keys(checkout_data?.installment || {})
      .map(key => checkout_data.installment[key]?.installment_amount || 0)
      .reduce((sum, amount) => sum + amount, 0);

    return {
      installment: totalAmount,
    };
  };

  const rounded_amount = Math.round(getTotalAmounts().installment);

  const calculateAmountData = (data, type) => {
    if (!data || !data[type]) return [];

    let amountData = Object.keys(data[type])
      .filter(key => data[type][key] !== undefined)
      .map(key => parseFloat(data[type][key].amount || 0));

    for (let i = 0; i < amountData.length - 1; i++) {
      total_mount += Math.round(amountData[i]);
    }

    for (let j = 0; j < amountData.length; j++) {
      amountData[j] = Math.round(amountData[j]);
      if (amountData[amountData.length - 1]) {
        amountData[amountData.length - 1] = rounded_amount - total_mount;
      }
    }

    return amountData;
  };

  // Hesaplamaları yap
  const servicesAmountData = calculateAmountData(checkout_data, 'services');
  const installmentAmountData = calculateAmountData(checkout_data, 'installment');

  // Servis ve taksit verilerini güncelle
  /*if (checkout_data && checkout_data.services) {
    Object.keys(checkout_data.services).forEach((key) => {
      if (checkout_data.services[key] !== undefined) {
        checkout_data.services[key].amount = Math.round(servicesAmountData[key] || 0);
      }
    });
  }

  if (checkout_data && checkout_data.installment) {
    Object.keys(checkout_data.installment).forEach((key) => {
      if (checkout_data.installment[key] !== undefined) {
        checkout_data.installment[key].amount = Math.round(installmentAmountData[key] || 0);
      }
    });
  }*/

  // Function to handle payment changes
  const handlePaymentChange = useCallback((paymentId, updatedData) => {
    if (!checkout_data || !updatedData) return;

    // Eğer miktar değişikliği varsa, kaydedilmemiş değişiklikler olduğunu işaretle
    if ('pay_amount' in updatedData) {
      setHasUnsavedChanges(true);
      setSaveButtonDisabled(false); // Kaydet butonunu aktif et
    }

    // Güncellenecek ödemeyi bul
    const paymentKey = Object.keys(checkout_data.paids || {}).find(
      key => checkout_data.paids[key]?.id === paymentId
    );

    if (!paymentKey || !checkout_data.paids[paymentKey]) {
      console.warn("Geçersiz ödeme anahtarı veya veri");
      return;
    }

    const payment = checkout_data.paids[paymentKey];

    // Match değeri kontrolü - grup güncellemesi gerekiyor mu?
    if (payment.match && payment.match > 0 && 'pay_amount' in updatedData) {
      // Aynı match değerine sahip tüm ödemeleri bul
      const matchedPaymentKeys = Object.keys(checkout_data.paids || {})
        .filter(key =>
          checkout_data.paids[key]?.match === payment.match &&
          checkout_data.paids[key] !== undefined
        );

      // Eğer birden fazla eşleşen ödeme varsa, grup güncellemesi yap
      if (matchedPaymentKeys.length > 1) {
        // Yeni toplam tutar - bu değer direkt kullanıcının girdiği değerdir
        const exactTotalAmount = parseInt(updatedData.pay_amount || 0);

        // Güncellenmiş checkout verisi
        let updatedCheckoutData = { ...checkout_data };
        // API için ödeme verileri
        let updatedPayments = [];

        // Mevcut toplam tutarı hesapla
        const totalOriginalAmount = matchedPaymentKeys.reduce(
          (sum, key) => sum + parseFloat(checkout_data.paids[key]?.pay_amount || 0),
          0
        );

        // Toplam tutardaki farkı hesapla
        const amountDifference = exactTotalAmount - totalOriginalAmount;

        // Tamamlanmış ödemeleri değiştirmeden koru (son ödeme hariç)
        let runningTotal = 0;

        // Ödemeleri güncelle (son ödeme hariç)
        for (let i = 0; i < matchedPaymentKeys.length - 1; i++) {
          const key = matchedPaymentKeys[i];
          const currentPayment = checkout_data.paids[key];

          // Mevcut tutarı koru
          const currentAmount = parseFloat(currentPayment.pay_amount || 0);
          runningTotal += currentAmount;

          // Ödeme nesnesini güncelle (tutarı değiştirmeden)
          updatedCheckoutData.paids[key] = {
            ...currentPayment,
            pay_amount: currentAmount
          };

          // API için ödeme verisini hazırla
          updatedPayments.push({
            payment_id: parseInt(currentPayment.id),
            payment_date: updatedData.payment_date
              ? moment(updatedData.payment_date).toISOString()
              : moment(currentPayment.payment_date).toISOString(),
            payment_type: updatedData.payment_type !== undefined
              ? Number(updatedData.payment_type)
              : Number(currentPayment.payment_type),
            staff_id: updatedData.staff_id !== undefined
              ? parseInt(updatedData.staff_id)
              : parseInt(currentPayment.staff_id),
            amount: currentAmount,
            payment_status: updatedData.payment_status !== undefined
              ? updatedData.payment_status
              : currentPayment.payment_status,
            sale_id: updatedData.sale_id !== undefined
              ? updatedData.sale_id
              : currentPayment.sale_id,
            sale_type: updatedData.sale_type !== undefined
              ? updatedData.sale_type
              : currentPayment.sale_type
          });
        }

        // Son ödemeyi hesapla - tüm değişikliği son ödemeye yansıt
        const lastKey = matchedPaymentKeys[matchedPaymentKeys.length - 1];
        const lastPayment = checkout_data.paids[lastKey];

        // Son ödemenin tutarını, toplam değişimi ekleyerek hesapla
        const lastAmount = Math.max(0, exactTotalAmount - runningTotal);

        // Son ödemeyi güncelle
        updatedCheckoutData.paids[lastKey] = {
          ...lastPayment,
          pay_amount: lastAmount
        };

        // Son ödemeyi API listesine ekle
        updatedPayments.push({
          payment_id: parseInt(lastPayment.id),
          payment_date: updatedData.payment_date
            ? moment(updatedData.payment_date).toISOString()
            : moment(lastPayment.payment_date).toISOString(),
          payment_type: updatedData.payment_type !== undefined
            ? Number(updatedData.payment_type)
            : Number(lastPayment.payment_type),
          staff_id: updatedData.staff_id !== undefined
            ? parseInt(updatedData.staff_id)
            : parseInt(lastPayment.staff_id),
          amount: lastAmount,
          payment_status: updatedData.payment_status !== undefined
            ? updatedData.payment_status
            : lastPayment.payment_status,
          sale_id: updatedData.sale_id !== undefined
            ? updatedData.sale_id
            : lastPayment.sale_id,
          sale_type: updatedData.sale_type !== undefined
            ? updatedData.sale_type
            : lastPayment.sale_type
        });

        // State'i güncelle
        setCheckoutData(updatedCheckoutData);

        // API için çağrıyı hazırla
        if ('pay_amount' in updatedData) {
          setPendingPaymentUpdate({
            isGroup: true,
            matchId: payment.match,
            receipt_id: parseInt(checkout_data?.receipt_id),
            payments: updatedPayments
          });
        } else {
          // Miktar değişmediyse hemen API çağrısını yap
          singlePaymentAndInstallmentPayment({
            receipt_id: parseInt(checkout_data?.receipt_id),
            id: parseInt(paymentId),
            receipt_type: 1,
            is_installment: false,
            payments: updatedPayments
          });
        }

        return;
      }
    }

    // Tekil ödeme güncellemesi
    const updatedPayment = {
      ...payment,
      ...updatedData
    };

    // Checkout verilerini güncelle
    const updatedCheckoutData = {
      ...checkout_data,
      paids: {
        ...checkout_data.paids,
        [paymentKey]: updatedPayment
      }
    };

    setCheckoutData(updatedCheckoutData);

    // Miktar güncellemesi için debounce kullan
    if ('pay_amount' in updatedData) {
      setPendingPaymentUpdate({
        paymentId,
        paymentKey,
        data: updatedData
      });
      return;
    }

    // Diğer değişiklikler için hemen API çağrısı yap
    const paymentData = {
      receipt_id: parseInt(checkout_data?.receipt_id),
      id: parseInt(paymentId),
      receipt_type: 1,
      is_installment: false,
      payments: [{
        payment_id: parseInt(paymentId),
        payment_date: updatedData.payment_date
          ? moment(updatedData.payment_date).toISOString()
          : moment(payment.payment_date).toISOString(),
        payment_type: updatedData.payment_type !== undefined
          ? Number(updatedData.payment_type)
          : Number(payment.payment_type),
        staff_id: updatedData.staff_id !== undefined
          ? parseInt(updatedData.staff_id)
          : parseInt(payment.staff_id),
        amount: updatedData.pay_amount !== undefined
          ? parseFloat(updatedData.pay_amount)
          : parseFloat(payment.pay_amount),
        payment_status: updatedData.payment_status !== undefined
          ? updatedData.payment_status
          : payment.payment_status,
        sale_id: updatedData.sale_id !== undefined
          ? updatedData.sale_id
          : payment.sale_id,
        sale_type: updatedData.sale_type !== undefined
          ? updatedData.sale_type
          : payment.sale_type
      }]
    };

    singlePaymentAndInstallmentPayment(paymentData);
  }, [checkout_data, setCheckoutData, singlePaymentAndInstallmentPayment, setHasUnsavedChanges, setSaveButtonDisabled]);



  useEffect(() => {
    if (is_change === true) {
      // Eğer değişiklik varsa ve otomatik kaydedilmesi gerekiyorsa
      if (!hasUnsavedChanges) {
        saveSingleReceipt();
        // Adisyon kaydedildiğinde, kaydedilmemiş değişiklikler işaretini temizle
        setHasUnsavedChanges(false);
        setSaveDialogOpen(false);
        setSaveDialogOpenInstallment(false);
        setAddPaymentDialog(true);
      }
    }
  }, [is_change, saveSingleReceipt, setHasUnsavedChanges, hasUnsavedChanges, setSaveDialogOpen, setSaveDialogOpenInstallment, setAddPaymentDialog]);

  // Ödeme işlemlerini yapmadan önce değişiklikleri kontrol eden fonksiyon
  const checkUnsavedChangesBeforePayment = (callback) => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveDialogOpen(true);
    } else {
      setAddPaymentDialog(true);
    }
  };

  const checkUnsavedChangesBeforePaymentInstallment = () => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveDialogOpenInstallment(true);
    } else {
      setInstallmentDialog(true);
    }
  };

  // Adisyonu kaydet ve sonra callback'i çalıştır
  const saveReceiptAndContinue = () => {
    setHasUnsavedChanges(false);
    setSaveDialogOpen(false);
    setLastSaveTimestamp(Date.now());
    saveSingleReceipt();
    setTimeout(() => {
      setAddPaymentDialog(true);
    }, 300);
  };

  const saveReceiptAndContinueCredit = () => {
    setHasUnsavedChanges(false);
    setSaveDialogOpenInstallment(false);
    setLastSaveTimestamp(Date.now());
    saveSingleReceipt();
    setTimeout(() => {
      setInstallmentDialog(true);
    }, 300);
  };

  // Effect to handle debounced payment amount changes
  useEffect(() => {
    if (!pendingPaymentUpdate) return;

    const timer = setTimeout(() => {
      // Grup güncelleme (match değeri olan ödemeler)
      if (pendingPaymentUpdate.isGroup) {
        const paymentData = {
          receipt_id: parseInt(checkout_data?.receipt_id),
          id: parseInt(pendingPaymentUpdate.matchId || 0),
          receipt_type: 1,
          is_installment: false,
          payments: pendingPaymentUpdate.payments
        };

        singlePaymentAndInstallmentPayment(paymentData);
      }
      // Tekil ödeme güncellemesi
      else if (pendingPaymentUpdate.paymentId) {
        const paymentKey = pendingPaymentUpdate.paymentKey;
        const payment = checkout_data.paids[paymentKey];

        if (!payment) {
          console.warn("Ödeme bulunamadı:", pendingPaymentUpdate.paymentId);
          setPendingPaymentUpdate(null);
          return;
        }

        const paymentData = {
          receipt_id: parseInt(checkout_data?.receipt_id),
          id: parseInt(pendingPaymentUpdate.paymentId),
          receipt_type: 1,
          is_installment: false,
          payments: [{
            payment_id: parseInt(pendingPaymentUpdate.paymentId),
            payment_date: pendingPaymentUpdate.data.payment_date
              ? moment(pendingPaymentUpdate.data.payment_date).toISOString()
              : moment(payment.payment_date || new Date()).toISOString(),
            payment_type: pendingPaymentUpdate.data.payment_type !== undefined
              ? Number(pendingPaymentUpdate.data.payment_type)
              : Number(payment.payment_type || 0),
            staff_id: pendingPaymentUpdate.data.staff_id !== undefined
              ? parseInt(pendingPaymentUpdate.data.staff_id)
              : parseInt(payment.staff_id || 0),
            amount: pendingPaymentUpdate.data.pay_amount !== undefined
              ? parseFloat(pendingPaymentUpdate.data.pay_amount)
              : parseFloat(payment.pay_amount || 0),
            payment_status: pendingPaymentUpdate.data.payment_status !== undefined
              ? pendingPaymentUpdate.data.payment_status
              : payment.payment_status || 1,
            sale_id: pendingPaymentUpdate.data.sale_id !== undefined
              ? pendingPaymentUpdate.data.sale_id
              : payment.sale_id,
            sale_type: pendingPaymentUpdate.data.sale_type !== undefined
              ? pendingPaymentUpdate.data.sale_type
              : payment.sale_type
          }]
        };

        singlePaymentAndInstallmentPayment(paymentData);
      }

      setPendingPaymentUpdate(null);
    }, 750);

    return () => clearTimeout(timer);
  }, [pendingPaymentUpdate, checkout_data, singlePaymentAndInstallmentPayment]);

  return (
    <>
      {/* Kaydedilmemiş değişiklikler olduğunda gösterilecek dialog */}
      <AlertDialog
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
            <span>Adisyonu Kaydetmediniz</span>
          </div>
        }
        open={saveDialogOpen}
        fullWidth
        maxWidth="xs"
        closeHandler={() => setSaveDialogOpen(false)}
        buttons={[
          {
            title: "Kaydet ve Devam Et",
            icon: "check",
            backgroundColor: "green",
            validationButton: true,
            style: { height: "56px" },
            textColor: "white",
            onClick: () => saveReceiptAndContinue(),
          },
          {
            title: "İptal",
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setSaveDialogOpen(false),
          },
        ]}
      >
        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
      </AlertDialog>
      <AlertDialog
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
            <span>Adisyonu Kaydetmediniz</span>
          </div>
        }
        open={saveDialogOpenInstallment}
        fullWidth
        maxWidth="xs"
        closeHandler={() => setSaveDialogOpenInstallment(false)}
        buttons={[
          {
            title: "Kaydet ve Devam Et",
            icon: "check",
            backgroundColor: "green",
            validationButton: true,
            style: { height: "56px", },
            textColor: "white",
            onClick: () => saveReceiptAndContinueCredit(),
          },
          {
            title: "İptal",
            icon: "close",
            backgroundColor: "white",
            style: {
              border: "1px solid #666666",
              height: "56px",
            },
            textColor: "black",
            onClick: () => setSaveDialogOpenInstallment(false),
          },
        ]}
      >
        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
      </AlertDialog>
      <SectionBox style={{ overflowX: "hidden" }}>
        <SectionHeading
          style={{
            backgroundColor: "rgba(29,139,62, 0.08)",
            color: "green",
            border: "1px solid green",
            padding: "10px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            onClick={() => setPaymentDetailDialogModal(true)}
            className="detail-search"
            style={{ backgroundColor: "green" }}
          >
            <Search style={{ color: "white", fontSize: "20px" }} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Payment />
            <h3 style={{ marginLeft: "15px" }}>
              {context.t(`['receipt/detail/id'].payments.title`)}
            </h3>
          </div>
          <div>
            <AddBox
              style={{ cursor: "pointer", fontSize: "36px" }}
              onClick={() => {
                checkUnsavedChangesBeforePayment();
              }}
            />
          </div>
        </SectionHeading>

        <AlertDialog
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "5px",
              }}
            >
              <AddOutlined
                style={{
                  color: "#6097D2",
                }}
              />
              <span
                style={{
                  color: "#6097D2",
                }}
              >
                {context.t(`['receipt/detail/id'].addPaymentTitle`)}
              </span>
            </div>
          }
          open={addPayment_dialog}
          fullWidth
          maxWidth="xs"
          closeHandler={() => setAddPaymentDialog(false)}
          buttons={[
            {
              title: context.t(
                `appointments.create.completePaymentButtonTitle`
              ),
              icon: "check",
              backgroundColor: "green",
              validationButton: true,
              style: {
                height: "56px",
              },
              textColor: "white",
              onClick: () => {
                if (!advanced_date || !advanced_amount || advanced_amount <= 0) {
                  toast.error('Lütfen tüm alanları doldurunuz!');
                  return;
                }

                singlePaymentAndInstallmentPayment({
                  receipt_id: parseInt(checkout_data?.receipt_id),
                  id: parseInt(selectedItem?.value),
                  receipt_type: selectedItem?.type === 'service' ? 1 : selectedItem?.type === 'package' ? 2 : 3,
                  is_installment: false,
                  payments: [{
                    payment_date: moment(advanced_date).toISOString(),
                    payment_type: Number(advanced_type),
                    staff_id: parseInt(payment_select_staff?.staff_id),
                    amount: parseFloat(advanced_amount),
                    payment_status: 1,
                    sale_id: parseInt(selectedItem?.value),
                    sale_type: selectedItem?.type === 'service' ? 1 : selectedItem?.type === 'package' ? 2 : 3
                  }]
                })
                setAddPaymentDialog(false);
                setSelectedItem(null)
                setSelectedInstallment(null)
                setInstallmentDate(null)
                setSelectedStaff(null)
                setAdvancedDate(new Date())
                setAdvancedType(0)
                setAdvancedAmount(0)
                setAdvancedStaff(null)
                setAddPaymentDialog(false)
              },
            },
            {
              title: context.t(`appointments.create.discardButtonTitle`),
              icon: "close",
              backgroundColor: "white",
              style: {
                border: "1px solid #666666",
                height: "56px",
              },
              textColor: "black",
              onClick: () => {
                setAddPaymentDialog(false);
                setPaymentSelectStaff({});
                setAdvancedStaff(null);
                setSelectedItem(null)
                setSelectedInstallment(null)
                setInstallmentDate(null)
                setSelectedStaff(null)
                setAdvancedDate(new Date())
                setAdvancedType(0)
                setAdvancedStaff(null)
              },
            },
          ]}
        >
          <>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
              </span>
              <DatePickerInput
                // label={context.t(
                //   `['receipt/detail/id'].payments.dateInputLabel`
                // )}
                value={moment(advanced_date).local().toISOString() || new Date()}
                onChange={(payment_date) => {
                  setAdvancedDate(payment_date)
                  handlePaymentChange(Object.keys(checkout_data.paids)[0], { payment_date });
                }}
              />
            </Column>
            <Column>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <AdvancedType
                  style={{
                    backgroundColor: advanced_type == 0 ? "#78B8FF" : "#FFFFFF",
                    filter:
                      advanced_type == 0
                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                    border:
                      advanced_type == 0
                        ? "1px solid #6BB0FE"
                        : "1px solid #b8b8b8",
                  }}
                  onClick={() => setAdvancedType(0)}
                >
                  {advanced_type == 0 ? (
                    <img src={CashWhite} alt="cash_white" />
                  ) : (
                    <img src={Cash} alt="cash" />
                  )}
                  <span
                    style={{
                      color: advanced_type == 0 ? "#FFFFFF" : "#000000",
                    }}
                  >
                    {context.t(`accounting.typeCASH`)}
                  </span>
                </AdvancedType>
                <AdvancedType
                  style={{
                    marginLeft: "10px",
                    backgroundColor: advanced_type == 2 ? "#78B8FF" : "#FFFFFF",
                    filter:
                      advanced_type == 2
                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                    border:
                      advanced_type == 2
                        ? "1px solid #6BB0FE"
                        : "1px solid #b8b8b8",
                  }}
                  onClick={() => {
                    setAdvancedType(2);
                  }}
                >
                  {advanced_type == 2 ? (
                    <img src={TransferWhite} alt="transfer_white" />
                  ) : (
                    <img src={Transfer} alt="transfer" />
                  )}
                  <span
                    style={{
                      color: advanced_type == 2 ? "#FFFFFF" : "#000000",
                    }}
                  >
                    {context.t(`accounting.typeEFT`)}
                  </span>
                </AdvancedType>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <AdvancedType
                  style={{
                    backgroundColor: advanced_type == 1 ? "#78B8FF" : "#FFFFFF",
                    filter:
                      advanced_type == 1
                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                    border:
                      advanced_type == 1
                        ? "1px solid #6BB0FE"
                        : "1px solid #b8b8b8",
                  }}
                  onClick={() => {
                    setAdvancedType(1);
                  }}
                >
                  {advanced_type == 1 ? (
                    <img src={CreditWhite} alt="credit_white" />
                  ) : (
                    <img src={Credit} alt="credit" />
                  )}
                  <span
                    style={{
                      color: advanced_type == 1 ? "#FFFFFF" : "#000000",
                    }}
                  >
                    {context.t(`accounting.typeCARD`)}
                  </span>
                </AdvancedType>
                <AdvancedType
                  style={{
                    marginLeft: "10px",
                    backgroundColor: advanced_type == 3 ? "#78B8FF" : "#FFFFFF",
                    filter:
                      advanced_type == 3
                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                    border:
                      advanced_type == 3
                        ? "1px solid #6BB0FE"
                        : "1px solid #b8b8b8",
                  }}
                  onClick={() => {
                    setAdvancedType(3);
                  }}
                >
                  {advanced_type == 3 ? (
                    <img src={CustomerPointWhite} alt="customer_point_white" />
                  ) : (
                    <img src={CustomerPoint} alt="customer_point" />
                  )}
                  <span
                    style={{
                      color: advanced_type == 3 ? "#FFFFFF" : "#000000",
                    }}
                  >
                    {context.t(`["accounting/expense"].payments.cusPoint`)}
                  </span>
                </AdvancedType>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <AdvancedType
                  style={{
                    backgroundColor: advanced_type == 4 ? "#78B8FF" : "#FFFFFF",
                    filter:
                      advanced_type == 4
                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                    border:
                      advanced_type == 4
                        ? "1px solid #6BB0FE"
                        : "1px solid #b8b8b8",
                  }}
                  onClick={() => {
                    setAdvancedType(4);
                  }}
                >
                  {advanced_type == 4 ? (
                    <img style={{ filter: "brightness(0) invert(1)", width: "60px"}} src={Iyzico} alt="check_white" />
                  ) : (
                    <img style={{ width: "60px"}} src={Iyzico} alt="check" />
                  )}
                  <span
                    style={{
                      color: advanced_type == 4 ? "#FFFFFF" : "#000000",
                    }}
                  >
                    {context.t(`accounting.typeCHECK`)}
                  </span>
                </AdvancedType>
</div>
            </Column>
            <Column>
              <StaffSelect
                disabled={context.state.user.permission === 0}
                label={context.t(`["receipt/detail/id"].selectStaff`)}
                items={staffs}
                selected={payment_select_staff?.staff_id}
                labelKey="full_name"
                valueKey="id"
                returnFullObject
                handler={(staff) => {
                  setAdvancedStaff(staff);
                  setPaymentSelectStaff({
                    ...payment_select_staff,
                    staff_id: parseInt(staff.id),
                  });
                }}
              />
            </Column>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].serviceTransactions.serviceInputLabel`)}
              </span>
              <Select
                label={"Satış Seçiniz (Opsiyonel)"}
                items={(() => {
                  // Helper function to get payment info for an item
                  const getItemPaymentInfo = (itemId, itemType) => {
                    // Normalize itemType to number for consistent comparison
                    let normalizedItemType;
                    if (itemType === 'service' || itemType === 1) {
                      normalizedItemType = 1;
                    } else if (itemType === 'package' || itemType === 2) {
                      normalizedItemType = 2;
                    } else if (itemType === 'sale' || itemType === 3) {
                      normalizedItemType = 3;
                    } else {
                      normalizedItemType = itemType;
                    }

                    // Get total paid amount for this specific item
                    const totalPaidForItem = Object.values(checkout_data?.paids || {})
                      .filter(payment => {
                        if (payment === undefined) return false;

                        // Check if payment is for this specific item
                        const paymentSaleId = parseInt(payment.sale_id);
                        const paymentSaleType = parseInt(payment.sale_type);
                        const targetItemId = parseInt(itemId);

                        return paymentSaleId === targetItemId && paymentSaleType === normalizedItemType;
                      })
                      .reduce((sum, payment) => sum + parseFloat(payment.pay_amount || 0), 0);

                    // Get total installment amount for this specific item (paid installments only)
                    const totalInstallmentForItem = Object.values(checkout_data?.installment || {})
                      .filter(installment => {
                        if (installment === undefined) return false;

                        // Check if installment is for this specific item and is paid
                        const installmentSaleId = parseInt(installment.sale_id);
                        const installmentSaleType = parseInt(installment.sale_type);
                        const targetItemId = parseInt(itemId);

                        return installmentSaleId === targetItemId &&
                          installmentSaleType === normalizedItemType &&
                          installment.installment_status === 1; // Only paid installments
                      })
                      .reduce((sum, installment) => sum + parseFloat(installment.installment_amount || 0), 0);

                    // Get item's total amount
                    let itemAmount = 0;
                    if (normalizedItemType === 1) {
                      const service = Object.values(checkout_data?.services || {}).find(s => parseInt(s?.id) === parseInt(itemId)) ||
                        Object.values(checkout_data?.packages || {}).find(p => parseInt(p?.id) === parseInt(itemId));
                      itemAmount = parseFloat(service?.amount || 0);
                    } else if (normalizedItemType === 2) {
                      const pkg = Object.values(checkout_data?.groupsAmount || {}).find(g => parseInt(g?.id) === parseInt(itemId));
                      itemAmount = parseFloat(pkg?.amount || 0);
                    } else if (normalizedItemType === 3) {
                      const sale = Object.values(checkout_data?.sales || {}).find(s => parseInt(s?.id) === parseInt(itemId));
                      itemAmount = parseFloat(sale?.amount || 0) * parseFloat(sale?.quantity || 1);
                    }

                    const totalPaid = totalPaidForItem + totalInstallmentForItem;
                    const remainingAmount = Math.max(0, itemAmount - totalPaid);
                    const isPaid = totalPaid >= itemAmount;

                    // if (itemId) {
                    //   console.log(`🔍 Item ${itemId} (type ${normalizedItemType}): Total=${itemAmount}, Paid=${totalPaid}, Remaining=${remainingAmount}, IsPaid=${isPaid}`);
                    // }

                    return {
                      totalAmount: itemAmount,
                      totalPaid: totalPaid,
                      remainingAmount: remainingAmount,
                      isPaid: isPaid
                    };
                  };

                  // Helper function to check if an item is fully paid
                  const isItemPaid = (itemId, itemType) => {
                    return getItemPaymentInfo(itemId, itemType).isPaid;
                  };

                  // Transform services into array format
                  const servicesArray = Object.keys(checkout_data?.services || {})
                    .filter(key => checkout_data?.services[key] !== undefined)
                    .map(key => {
                      const service = checkout_data.services[key];
                      const currency = context.state.currency || "₺";
                      const paymentInfo = getItemPaymentInfo(service.id, 'service');
                      const remainingAmount = Math.round(paymentInfo.remainingAmount);
                      const totalAmount = Math.round(paymentInfo.totalAmount);
                      const serviceName = services.find(s => s.id === service.service_id)?.name;
                      const labelText = paymentInfo.isPaid
                        ? `${serviceName} - Ödendi`
                        : `${serviceName} - Toplam: ${totalAmount}${currency}, Kalan: ${remainingAmount}${currency}`;
                      return {
                        label: labelText,
                        value: service.id,
                        type: 'service',
                        isPaid: paymentInfo.isPaid,
                        backgroundColor: paymentInfo.isPaid ? '#e8f5e8' : '#ffe8e8',
                        color: paymentInfo.isPaid ? '#2e7d32' : '#d32f2f'
                      };
                    });

                  // Transform packages into array format
                  const groupAmountArray = Object.keys(checkout_data?.groupsAmount || {})
                    .filter(key => checkout_data?.groupsAmount[key] !== undefined)
                    .map(key => {
                      const pkg = checkout_data.groupsAmount[key];
                      const currency = context.state.currency || "₺";
                      const paymentInfo = getItemPaymentInfo(pkg.id, 'package');
                      const remainingAmount = Math.round(paymentInfo.remainingAmount);
                      const totalAmount = Math.round(paymentInfo.totalAmount);
                      const labelText = paymentInfo.isPaid
                        ? `${pkg.package_name} - Ödendi`
                        : `${pkg.package_name} - Toplam: ${totalAmount}${currency}, Kalan: ${remainingAmount}${currency}`;
                      return {
                        label: labelText,
                        value: pkg.id,
                        type: 'package',
                        isPaid: paymentInfo.isPaid,
                        backgroundColor: paymentInfo.isPaid ? '#e8f5e8' : '#ffe8e8',
                        color: paymentInfo.isPaid ? '#2e7d32' : '#d32f2f'
                      };
                    });

                  // Transform packages into array format
                  const packagesArray = Object.keys(checkout_data?.packages || {})
                    .filter(key => checkout_data?.packages[key] !== undefined)
                    .map(key => {
                      const pkg = checkout_data.packages[key];
                      const currency = context.state.currency || "₺";
                      const paymentInfo = getItemPaymentInfo(pkg.id, 'service');
                      const remainingAmount = Math.round(paymentInfo.remainingAmount);
                      const totalAmount = Math.round(paymentInfo.totalAmount);
                      const serviceName = services.find(s => s.id === pkg.service_id)?.name;
                      const labelText = paymentInfo.isPaid
                        ? `${serviceName} - Ödendi`
                        : `${serviceName} - Toplam: ${totalAmount}${currency}, Kalan: ${remainingAmount}${currency}`;
                      return {
                        label: labelText,
                        value: pkg.id,
                        type: 'service',
                        isPaid: paymentInfo.isPaid,
                        backgroundColor: paymentInfo.isPaid ? '#e8f5e8' : '#ffe8e8',
                        color: paymentInfo.isPaid ? '#2e7d32' : '#d32f2f'
                      };
                    });

                  // Transform sales into array format
                  const salesArray = Object.keys(checkout_data?.sales || {})
                    .filter(key => checkout_data?.sales[key] !== undefined)
                    .map(key => {
                      const sale = checkout_data.sales[key];
                      const currency = context.state.currency || "₺";
                      const paymentInfo = getItemPaymentInfo(sale.id, 'sale');
                      const remainingAmount = Math.round(paymentInfo.remainingAmount);
                      const totalAmount = Math.round(paymentInfo.totalAmount);
                      const productName = stockItems.find(s => s.id === sale.stock_item_id)?.name;
                      const labelText = paymentInfo.isPaid
                        ? `${productName} - Ödendi`
                        : `${productName} - Toplam: ${totalAmount}${currency}, Kalan: ${remainingAmount}${currency}`;
                      return {
                        label: labelText,
                        value: sale.id,
                        type: 'sale',
                        isPaid: paymentInfo.isPaid,
                        backgroundColor: paymentInfo.isPaid ? '#e8f5e8' : '#ffe8e8',
                        color: paymentInfo.isPaid ? '#2e7d32' : '#d32f2f'
                      };
                    });

                  // Combine all arrays
                  return [...servicesArray, ...packagesArray, ...salesArray, ...groupAmountArray];
                })()}
                selected={selectedItem ? selectedItem.value : null}
                labelKey="label"
                valueKey="value"
                throwAll
                handler={(item) => {
                  setSelectedItem(item);
                  handleInstallmentChange({
                    item_id: item.value,
                    item_type: item.type
                  });

                  // Seçilen satışın kalan tutarını otomatik olarak ödeme tutarı alanına yaz
                  if (item && item.value && item.type) {
                    // Handler içinde getItemPaymentInfo fonksiyonunu tanımla
                    const getItemPaymentInfoHandler = (itemId, itemType) => {
                      // Normalize itemType to number for consistent comparison
                      let normalizedItemType;
                      if (itemType === 'service' || itemType === 1) {
                        normalizedItemType = 1;
                      } else if (itemType === 'package' || itemType === 2) {
                        normalizedItemType = 2;
                      } else if (itemType === 'sale' || itemType === 3) {
                        normalizedItemType = 3;
                      } else {
                        normalizedItemType = itemType;
                      }

                      // Get total paid amount for this specific item
                      const totalPaidForItem = Object.values(checkout_data?.paids || {})
                        .filter(payment => {
                          if (payment === undefined) return false;

                          // Check if payment is for this specific item
                          const paymentSaleId = parseInt(payment.sale_id);
                          const paymentSaleType = parseInt(payment.sale_type);
                          const targetItemId = parseInt(itemId);

                          return paymentSaleId === targetItemId && paymentSaleType === normalizedItemType;
                        })
                        .reduce((sum, payment) => sum + parseFloat(payment.pay_amount || 0), 0);

                      // Get total installment amount for this specific item (paid installments only)
                      const totalInstallmentForItem = Object.values(checkout_data?.installment || {})
                        .filter(installment => {
                          if (installment === undefined) return false;

                          // Check if installment is for this specific item and is paid
                          const installmentSaleId = parseInt(installment.sale_id);
                          const installmentSaleType = parseInt(installment.sale_type);
                          const targetItemId = parseInt(itemId);

                          return installmentSaleId === targetItemId &&
                            installmentSaleType === normalizedItemType &&
                            installment.installment_status === 1; // Only paid installments
                        })
                        .reduce((sum, installment) => sum + parseFloat(installment.installment_amount || 0), 0);

                      // Get item's total amount
                      let itemAmount = 0;
                      if (normalizedItemType === 1) {
                        const service = Object.values(checkout_data?.services || {}).find(s => parseInt(s?.id) === parseInt(itemId)) ||
                          Object.values(checkout_data?.packages || {}).find(p => parseInt(p?.id) === parseInt(itemId));
                        itemAmount = parseFloat(service?.amount || 0);
                      } else if (normalizedItemType === 2) {
                        const pkg = Object.values(checkout_data?.groupsAmount || {}).find(g => parseInt(g?.id) === parseInt(itemId));
                        itemAmount = parseFloat(pkg?.amount || 0);
                      } else if (normalizedItemType === 3) {
                        const sale = Object.values(checkout_data?.sales || {}).find(s => parseInt(s?.id) === parseInt(itemId));
                        itemAmount = parseFloat(sale?.amount || 0) * parseFloat(sale?.quantity || 1);
                      }

                      const totalPaid = totalPaidForItem + totalInstallmentForItem;
                      const remainingAmount = Math.max(0, itemAmount - totalPaid);
                      const isPaid = totalPaid >= itemAmount;

                      return {
                        totalAmount: itemAmount,
                        totalPaid: totalPaid,
                        remainingAmount: remainingAmount,
                        isPaid: isPaid
                      };
                    };

                    const paymentInfo = getItemPaymentInfoHandler(item.value, item.type);
                    const remainingAmount = Math.round(paymentInfo.remainingAmount);

                    // Sadece kalan tutar varsa ödeme tutarını güncelle
                    if (remainingAmount > 0) {
                      setAdvancedAmount(remainingAmount);
                    }
                  }
                }}
              />
            </Column>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].paymentAmount`)} *
              </span>
              <Input
                placeholder="Tutar giriniz"
                type="text"
                value={advanced_amount ? advanced_amount.toString() : ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^\d]/g, ''); // Sadece sayıları kabul et
                  const value = inputValue === '' ? 0 : parseFloat(inputValue);
                  setAdvancedAmount(value);
                  handlePaymentChange(Object.keys(checkout_data.paids)[0], { pay_amount: value });
                }}
              />
            </Column>
          </>
        </AlertDialog>
        <ListSection className="no-scroll-bar">
          {groupedPayments.length > 0 ? (
            groupedPayments.map((group, groupIndex) => (
              <React.Fragment key={`group-${group.matchId}-${groupIndex}`}>
                <Grid className="no-gutters-row" style={{ marginBottom: "10px", borderBottom: "1px solid #e5e5e5", paddingBottom: "5px" }}>
                  <Column className="xs-12 sm-6 md-4 mt-1 lg-2">
                    <MuiThemeProvider theme={themeForDatePicker}>
                      <DatePickerInput
                        label={context.t(
                          `['receipt/detail/id'].payments.dateInputLabel`
                        )}
                        value={
                          new Date(
                            moment(group.payment_date)
                              .local()
                              .toISOString()
                          )
                        }
                        onChange={(payment_date) => {
                          // Gruptaki tüm ödemelerin tarihini güncelle
                          group.payments.forEach(payment => {
                            handlePaymentChange(payment.id, { ...payment, payment_date });
                          });
                        }}
                      />
                    </MuiThemeProvider>
                  </Column>

                  <Column className="xs-6 sm-6 md-4 lg-2">
                    <Select
                      label={context.t(
                        `['receipt/detail/id'].payments.typeInputLabel`
                      )}
                      items={[
                        {
                          label: context.t(`['receipt/detail/id'].payments.typeCASH`),
                          value: "0",
                        },
                        {
                          label: context.t(`['receipt/detail/id'].payments.typeCARD`),
                          value: "1",
                        },
                        {
                          label: context.t(`['receipt/detail/id'].payments.typeEFT`),
                          value: "2",
                        },
                        {
                          label: context.t(`['receipt/detail/id'].payments.typePOINT`),
                          value: "3",
                        },
                        
                      ]}
                      selected={String(Number(group.payment_type))}
                      labelKey="label"
                      valueKey="value"
                      handler={(payment_type) => {
                        // Gruptaki tüm ödemelerin türünü güncelle
                        const paymentType = Number(payment_type);
                        group.payments.forEach(payment => {
                          handlePaymentChange(payment.id, { ...payment, payment_type: paymentType });
                        });
                      }}
                    />
                  </Column>

                  <Column className="xs-12 sm-6 md-4 lg-2">
                    <Select
                      label={"İşlem Adı"}
                      items={(() => {
                        // Tüm servisleri, paketleri ve ürünleri birleştirerek select options oluştur
                        const allItems = [
                          { label: 'Genel Ödeme', value: null, type: null },
                          ...Object.values(checkout_data?.services || {})
                            .filter(service => service !== undefined)
                            .map(service => ({
                              label: services.find(s => s.id === service.service_id)?.name || 'Bilinmeyen Servis',
                              value: service.id,
                              type: 1 // service type
                            })),
                          ...Object.values(checkout_data?.packages || {})
                            .filter(pkg => pkg !== undefined)
                            .map(pkg => ({
                              label: services.find(s => s.id === pkg.service_id)?.name || 'Bilinmeyen Seans',
                              value: pkg.id,
                              type: 2 // package type
                            })),
                          ...Object.values(checkout_data?.groupsAmount || {})
                            .filter(group => group !== undefined)
                            .map(group => ({
                              label: group.package_name || 'Bilinmeyen Paket',
                              value: group.id,
                              type: 2 // package type
                            })),
                          ...Object.values(checkout_data?.sales || {})
                            .filter(sale => sale !== undefined)
                            .map(sale => ({
                              label: stockItems.find(s => s.id === sale.stock_item_id)?.name || 'Bilinmeyen Ürün',
                              value: sale.id,
                              type: 3 // sale type
                            }))
                        ];
                        return allItems;
                      })()}
                      selected={group.payments[0]?.sale_id || null}
                      labelKey="label"
                      valueKey="value"
                      handler={(item) => {
                        // Gruptaki tüm ödemelerin sale_id ve sale_type değerlerini güncelle
                        group.payments.forEach(payment => {
                          const selectedItem = item && typeof item === 'object' ? item :
                            { value: item, type: null };
                          handlePaymentChange(payment.id, {
                            ...payment,
                            sale_id: selectedItem.value,
                            sale_type: selectedItem.type
                          });
                        });
                      }}
                    />
                  </Column>

                  <Column className="xs-6 sm-6 md-4 lg-2">
                    <Select
                      label={context.t(`["receipt/detail/id"].headingTitles.staff`)}
                      items={staffs}
                      selected={group.staff_id || ""}
                      labelKey="full_name"
                      valueKey="id"
                      handler={(staff_id) => {
                        const parsedStaffId = parseInt(staff_id);
                        group.payments.forEach(payment => {
                          handlePaymentChange(payment.id, { ...payment, staff_id: parsedStaffId });
                        });
                      }}
                    />
                  </Column>

                  <Column className="xs-6 sm-6 md-4 lg-2">
                    <Input
                      label={
                        group.payment_type === 3
                          ? context.t(
                            `['receipt/detail/id'].payments.pointInputLabel`
                          )
                          : context.t(
                            `['receipt/detail/id'].payments.amountInputLabel`
                          ) +
                          (context.state.currency
                            ? "(" + context.state.currency + ")"
                            : "₺")
                      }
                      type="text"
                      value={inputValues[`group-${group.matchId}`] !== undefined
                        ? inputValues[`group-${group.matchId}`]
                        : (group.total_amount ? group.total_amount.toString() : "")}
                      onChange={(e) => {
                        // Sadece input durumunu güncelle, API çağrısını yapma
                        let inputText = e.target.value.replace(/[^\d]/g, '');
                        setInputValues({
                          ...inputValues,
                          [`group-${group.matchId}`]: inputText
                        });
                      }}
                      onBlur={() => {
                        // Input'tan çıkıldığında değeri güncelle
                        if (inputValues[`group-${group.matchId}`] !== undefined) {
                          // Yeni toplam tutar - kullanıcının girdiği tam değeri al
                          const exactValue = inputValues[`group-${group.matchId}`] === ''
                            ? 0
                            : parseInt(inputValues[`group-${group.matchId}`]);

                          // Eğer ödemeler varsa güncelle
                          if (group.payments && group.payments.length > 0) {
                            // Son ödemeyi bul (tamamamlanmamış olan)
                            // Varsayılan olarak grup 0. indeksi kullan
                            let referencePaymentId = group.payments[0].id;

                            // Eğer birden fazla ödeme varsa son ödemeyi kullan
                            if (group.payments.length > 1) {
                              referencePaymentId = group.payments[group.payments.length - 1].id;
                            }

                            // Değişiklik için tam değeri kullan
                            const commonData = {
                              pay_amount: exactValue
                            };

                            // Ödemeler grubunun sadece son ödemesinde değişiklik yap
                            handlePaymentChange(referencePaymentId, commonData);
                          }
                        }
                      }}
                    />
                  </Column>

                  {/* Sadece grup olan ödemeler için Detay butonu göster */}
                  {group.isGroup ? (
                    <Column className="xs-6 sm-6 md-8 lg-1 ml-2" style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <div
                        style={{
                          backgroundColor: expandedMatch === group.matchId ? '#FF9016' : '#3189EC',
                          borderRadius: '5px',
                          padding: '5px 10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
                          minWidth: '80px',
                          cursor: 'pointer',
                          marginTop: "-25px"
                        }}
                        onClick={() => {
                          if (expandedMatch === group.matchId) {
                            setExpandedMatch(null);
                          } else {
                            setExpandedMatch(group.matchId);
                          }
                        }}
                      >
                        {expandedMatch === group.matchId ? (
                          <>
                            <ExpandLessIcon style={{ color: 'white', fontSize: '20px', marginRight: '3px' }} />
                            <span style={{ color: 'white', fontSize: '12px' }}>Gizle</span>
                          </>
                        ) : (
                          <>
                            <ExpandMoreIcon style={{ color: 'white', fontSize: '20px', marginRight: '3px' }} />
                            <span style={{ color: 'white', fontSize: '12px' }}>Detay ({group.payment_count})</span>
                          </>
                        )}
                      </div>
                    </Column>
                  ) : (
                    // Grup değilse silme butonu göster
                    <Column className="xs-3 sm-3 md-2 lg-1" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Delete
                        onClick={() => deleteSingleReceiptPayment(checkout_data.receipt_id, group.payments[0].id)}
                        style={{
                          cursor: "pointer",
                          color: "red",
                          fontSize: "24px"
                        }}
                      />
                    </Column>
                  )}
                </Grid>

                {/* Detay gösterimi */}
                {expandedMatch === group.matchId && (
                  <div style={{ marginLeft: '20px', marginBottom: '20px', borderLeft: '2px solid #3189EC', paddingLeft: '10px' }}>
                    {group.payments.map((payment, index) => (
                      <Grid className="no-gutters-row" key={`detail-${payment.id}-${index}`} style={{ marginBottom: '10px' }}>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Input
                            label={'Ödeme Tarihi'}
                            value={moment(payment.payment_date).format('DD/MM/YYYY')}
                            onChange={(e) => {
                              if (moment(e.target.value, 'DD/MM/YYYY', true).isValid()) {
                                handlePaymentChange(payment.id, {
                                  ...payment,
                                  payment_date: moment(e.target.value, 'DD/MM/YYYY').toISOString()
                                });
                              }
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Select
                            label={'Ödeme Türü'}
                            items={[
                              {
                                label: context.t(`['receipt/detail/id'].payments.typeCASH`),
                                value: "0",
                              },
                              {
                                label: context.t(`['receipt/detail/id'].payments.typeCARD`),
                                value: "1",
                              },
                              {
                                label: context.t(`['receipt/detail/id'].payments.typeEFT`),
                                value: "2",
                              },
                              {
                                label: context.t(`['receipt/detail/id'].payments.typePOINT`),
                                value: "3",
                              },
                            ]}
                            selected={String(Number(payment.payment_type))}
                            labelKey="label"
                            valueKey="value"
                            handler={(payment_type) => {
                              // Sayı olarak dönüştür
                              handlePaymentChange(payment.id, { ...payment, payment_type: Number(payment_type) });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Select
                            label={"İşlem Adı"}
                            items={(() => {
                              // Tüm servisleri, paketleri ve ürünleri birleştirerek select options oluştur
                              const allItems = [
                                { label: 'Genel Ödeme', value: null, type: null },
                                ...Object.values(checkout_data?.services || {})
                                  .filter(service => service !== undefined)
                                  .map(service => ({
                                    label: services.find(s => s.id === service.service_id)?.name || 'Bilinmeyen Servis',
                                    value: service.id,
                                    type: 1 // service type
                                  })),
                                ...Object.values(checkout_data?.packages || {})
                                  .filter(pkg => pkg !== undefined)
                                  .map(pkg => ({
                                    label: services.find(s => s.id === pkg.service_id)?.name || 'Bilinmeyen Seans',
                                    value: pkg.id,
                                    type: 2 // package type
                                  })),
                                ...Object.values(checkout_data?.groupsAmount || {})
                                  .filter(group => group !== undefined)
                                  .map(group => ({
                                    label: group.package_name || 'Bilinmeyen Paket',
                                    value: group.id,
                                    type: 2 // package type
                                  })),
                                ...Object.values(checkout_data?.sales || {})
                                  .filter(sale => sale !== undefined)
                                  .map(sale => ({
                                    label: stockItems.find(s => s.id === sale.stock_item_id)?.name || 'Bilinmeyen Ürün',
                                    value: sale.id,
                                    type: 3 // sale type
                                  }))
                              ];
                              return allItems;
                            })()}
                            selected={payment.sale_id || null}
                            labelKey="label"
                            valueKey="value"
                            handler={(item) => {
                              const selectedItem = item && typeof item === 'object' ? item :
                                { value: item, type: null };
                              handlePaymentChange(payment.id, {
                                ...payment,
                                sale_id: selectedItem.value,
                                sale_type: selectedItem.type
                              });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Select
                            label={'Personel'}
                            items={staffs}
                            selected={payment.staff_id || ""}
                            labelKey="full_name"
                            valueKey="id"
                            handler={(staff_id) => {
                              handlePaymentChange(payment.id, {
                                ...payment,
                                staff_id: parseInt(staff_id),
                              });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Input
                            label={'Tutar'}
                            type="text"
                            value={paymentDetailValue[payment.id] !== undefined
                              ? paymentDetailValue[payment.id]
                              : (payment.pay_amount ? payment.pay_amount.toString() : "")}
                            onChange={(e) => {
                              // Sadece input durumunu güncelle, API çağrısını yapma
                              let inputText = e.target.value.replace(/[^\d]/g, '');
                              setPaymentDetailValue({
                                ...paymentDetailValue,
                                [payment.id]: inputText
                              });
                            }}
                            onBlur={() => {
                              // Input'tan çıkıldığında değeri güncelle
                              if (paymentDetailValue[payment.id] !== undefined) {
                                const value = paymentDetailValue[payment.id] === ''
                                  ? 0
                                  : parseFloat(paymentDetailValue[payment.id]);

                                handlePaymentChange(payment.id, {
                                  ...payment,
                                  pay_amount: value
                                });
                              }
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-1">
                          <Delete
                            onClick={() => deleteSingleReceiptPayment(checkout_data.receipt_id, payment.id)}
                            size="small"
                            style={{ cursor: "pointer", color: "red", width: "20px", height: "20px", marginTop: "15px" }}
                          />
                        </Column>

                        {payment.sale_id !== null && selectedDetailAdvanced === payment && (
                          <Column className="xs-12 sm-12 md-12 lg-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Column className="xs-12 sm-12 md-12 lg-2">
                              <Input
                                label={'Satış Türü'}
                                value={
                                  payment.sale_type === 1
                                    ? 'Servis'
                                    : payment.sale_type === 2
                                      ? 'Paket'
                                      : payment.sale_type === 3
                                        ? 'Ürün'
                                        : 'Bulunamadı'
                                }
                              />
                            </Column>
                            <Column className="xs-12 sm-12 md-12 lg-3">
                              <Input
                                label={'Hizmet Adı'}
                                value={
                                  (() => {
                                    const allItems = [
                                      ...Object.values(checkout_data?.services || {}),
                                      ...Object.values(checkout_data?.packages || {}),
                                      ...Object.values(checkout_data?.groupsAmount || {}),
                                      ...Object.values(checkout_data?.sales || {})
                                    ];
                                    const foundItem = allItems.find(item => item.id === payment.sale_id);
                                    if (payment.sale_type === 3) {
                                      return foundItem?.stock_item?.name || 'Bulunamadı';
                                    } else if (payment.sale_type === 2) {
                                      if (foundItem?.package_name) {
                                        return foundItem?.package_name || 'Bulunamadı';
                                      } else {
                                        return foundItem?.Service?.name || 'Bulunamadı';
                                      }
                                    } else {
                                      return foundItem?.Service?.name || 'Bulunamadı';
                                    }
                                  })()
                                }
                              />
                            </Column>
                            <Column className="xs-12 sm-12 md-12 lg-3">
                              <Input
                                label={'Satış Fiyatı'}
                                value={
                                  (() => {
                                    const allItems = [
                                      ...Object.values(checkout_data?.services || {}),
                                      ...Object.values(checkout_data?.packages || {}),
                                      ...Object.values(checkout_data?.groupsAmount || {}),
                                      ...Object.values(checkout_data?.sales || {})
                                    ];
                                    const foundItem = allItems.find(item => item.id === payment.sale_id);
                                    return foundItem ? `${foundItem.amount}${currency}` : 'Bulunamadı';
                                  })()
                                }
                              />
                            </Column>
                          </Column>
                        )}
                      </Grid>
                    ))}
                  </div>
                )}
              </React.Fragment>
            ))
          ) : (
            <NoDataContainer style={{ height: "90%" }}>
              <img
                style={{ height: "80%" }}
                src={require("../../../../assets/images/manypixels/online_payment_.svg")}
                alt="Malesef bulunamadı!"
              />
              <p>{context.t(`['receipt/detail/id'].payments.noDataText`)}</p>
            </NoDataContainer>
          )}
        </ListSection>
      </SectionBox>

      {/* İnstallMent */}
      <SectionBox style={{ overflowX: "hidden" }}>
        <SectionHeading
          style={{
            backgroundColor: "rgba(255,0,0, 0.08)",
            color: "red",
            border: "1px solid red",
            padding: "10px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            className="detail-search"
            style={{
              backgroundColor: "red",
            }}
            onClick={() => {
              setPaymentDetailDialogModal(true);
            }}
          >
            <Search style={{ color: "white", fontSize: "20px" }} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Payment />
            <h3 style={{ marginLeft: "15px" }}>
              {" "}
              {context.t(`['receipt/detail/id'].installment.title`)}
            </h3>
          </div>
          <div>
            <AddBox
              style={{ cursor: "pointer", fontSize: "36px" }}
              onClick={() => {
                if (hasUnsavedChanges) {
                  setSaveDialogOpenInstallment(true);
                } else {
                  setInstallmentDialog(true);
                }
              }}
            />
          </div>
        </SectionHeading>
        <AlertDialog
          title={
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <span
                style={{
                  width: "120%",
                  marginTop: "15px",
                }}
              >
                {context.t(`['receipt/detail/id'].installmentProcess`)}
              </span>
              <CustomerBoxDiv>
                {parseFloat(getAllTotalService()) -
                  parseFloat(
                    getTotalAmounts().installment_total +
                    getTotalAmounts().paids
                  ) ===
                  0 ? (
                  <img src={RemainingDebt} alt="remaining_debt" />
                ) : (
                  <img src={RemainingDebtRed} alt="remaining_debt_red" />
                )}
                <CustomerPointBox>
                  <span>
                    {getInstallmentDiffTotal(1)}{" "}
                    {context.state.currency ? context.state.currency : "₺"}
                  </span>
                  <h3>{context.t(`['receipt/detail/id'].remainingDebt`)}</h3>
                </CustomerPointBox>
              </CustomerBoxDiv>
            </div>
          }
          open={installment_dialog}
          closeHandler={() => setInstallmentDialog(false)}
          fullWidth
          maxWidth="sm"
          buttons={[
            {
              title: context.t(`appointments.create.completeButtonTitle`),
              icon: "check",
              validationButton: true,
              backgroundColor: "green",
              style: {
                height: "56px",
              },
              textColor: "white",
              onClick: () => {
                if (!selectedItem || !installment_date || !selected_installment) {
                  toast.error('Lütfen tüm alanları doldurunuz!');
                  return;
                }
                singlePaymentAndInstallmentPayment({
                  receipt_id: parseInt(checkout_data.receipt_id),
                  id: parseInt(selectedItem.value),
                  receipt_type: selectedItem.type === 'service' ? 1 : selectedItem.type === 'package' ? 2 : 3,
                  is_installment: true,
                  payments: Array.from({ length: selected_installment }, (_, i) => ({
                    payment_date:
                      i === 0
                        ? moment(installment_date).toISOString()
                        : moment(installment_date)
                          .add(i, "months")
                          .toISOString(),
                    payment_type: Number(0), // String değil number olarak gönder
                    staff_id: parseInt(selectedStaff || 0),
                    amount: getInstallmentDiffTotal(selected_installment || 1),
                    payment_status: 0,
                    sale_id: parseInt(selectedItem?.value),
                    sale_type: selectedItem?.type === 'service' ? 1 : selectedItem?.type === 'package' ? 2 : 3
                  }))
                })
                setSelectedItem(null)
                setSelectedInstallment(null)
                setInstallmentDate(new Date())
                setSelectedStaff(null)
                setAdvancedDate(new Date())
                setAdvancedType(0)
                setAdvancedStaff(null)
                setInstallmentDialog(false)
              },
            },
            {
              title: context.t(`appointments.create.discardButtonTitle`),
              icon: "close",
              backgroundColor: "white",
              style: {
                border: "1px solid #666666",
                height: "56px",
              },
              textColor: "black",
              onClick: () => {
                setSelectedItem(null)
                setSelectedInstallment(null)
                setInstallmentDate(new Date())
                setSelectedStaff(null)
                setAdvancedDate(new Date())
                setAdvancedType(0)
                setAdvancedStaff(null)
              },
            },
          ]}
        >
          <>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
              </span>
              <DatePickerInput
                value={moment(installment_date).local().toISOString() || new Date()}
                onChange={(payment_date) => {
                  setInstallmentDate(payment_date);
                  handleInstallmentChange({ installment_date: payment_date });
                }}
              />
            </Column>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >

              </span>

              <StaffSelect
                className="mb-1"
                disabled={context.state.user.permission === 0}
                label={"Personel Seçiniz (Opsiyonel)"}
                items={staffs}
                selected={selectedStaff ? selectedStaff : ""}
                labelKey="full_name"
                valueKey="id"
                handler={(staff_id) => {
                  setSelectedStaff(staff_id);
                  handleInstallmentChange({ installment_staff: staff_id });
                }}
              />
            </Column>
            <Column>
              <span
                style={{
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].serviceTransactions.serviceInputLabel`)}
              </span>
              <Select
                label={"Satış Seçiniz *"}
                items={(() => {
                  // Transform services into array format
                  const servicesArray = Object.keys(checkout_data?.services || {})
                    .filter(key => checkout_data?.services[key] !== undefined)
                    .map(key => {
                      const service = checkout_data.services[key];
                      const currency = context.state.currency || "₺";
                      return {
                        label: `${services.find(s => s.id === service.service_id)?.name} - ${service.amount}${currency}`,
                        value: service.id,
                        type: 'service'
                      };
                    });

                  // Transform packages into array format
                  const groupAmountArray = Object.keys(checkout_data?.groupsAmount || {})
                    .filter(key => checkout_data?.groupsAmount[key] !== undefined)
                    .map(key => {
                      const pkg = checkout_data.groupsAmount[key];
                      const currency = context.state.currency || "₺";
                      return {
                        label: `${pkg.package_name} - ${pkg.amount}${currency}`,
                        value: pkg.id,
                        type: 'package'
                      };
                    });


                  // Transform packages into array format
                  const packagesArray = Object.keys(checkout_data?.packages || {})
                    .filter(key => checkout_data?.packages[key] !== undefined)
                    .map(key => {
                      const pkg = checkout_data.packages[key];
                      const currency = context.state.currency || "₺";
                      return {
                        label: `${services.find(s => s.id === pkg.service_id)?.name} - ${pkg.amount}${currency}`,
                        value: pkg.id,
                        type: 'service'
                      };
                    });

                  // Transform sales into array format
                  const salesArray = Object.keys(checkout_data?.sales || {})
                    .filter(key => checkout_data?.sales[key] !== undefined)
                    .map(key => {
                      const sale = checkout_data.sales[key];
                      const currency = context.state.currency || "₺";
                      return {
                        label: `${stockItems.find(s => s.id === sale.stock_item_id)?.name} - ${sale.amount}${currency}`,
                        value: sale.id,
                        type: 'sale'
                      };
                    });

                  // Combine all arrays
                  return [...servicesArray, ...packagesArray, ...salesArray, ...groupAmountArray];
                })()}
                selected={selectedItem ? selectedItem.value : null}
                labelKey="label"
                valueKey="value"
                throwAll
                handler={(item) => {
                  setSelectedItem(item);
                  handleInstallmentChange({
                    item_id: item.value,
                    item_type: item.type
                  });
                }}
              />
            </Column>
            <Column>
              <span
                style={{
                  marginTop: '20px !important',
                  marginBottom: "10px",
                  marginLeft: "5px",
                  fontSize: "18px",
                }}
              >
                {context.t(`["receipt/detail/id"].installmentCountInputLabel`)} *
              </span>
              <Select
                // label={context.t(
                //   `['receipt/detail/id'].installmentCountInputLabel`
                // )}
                labelKey="label"
                valueKey="value"
                items={[
                  { value: 2, label: context.t(`["receipt/detail/id"].installments.two`) },
                  { value: 3, label: context.t(`["receipt/detail/id"].installments.three`) },
                  { value: 4, label: context.t(`["receipt/detail/id"].installments.four`) },
                  { value: 5, label: context.t(`["receipt/detail/id"].installments.five`) },
                  { value: 6, label: context.t(`["receipt/detail/id"].installments.six`) },
                  { value: 7, label: context.t(`["receipt/detail/id"].installments.seven`) },
                  { value: 8, label: context.t(`["receipt/detail/id"].installments.eight`) },
                  { value: 9, label: context.t(`["receipt/detail/id"].installments.nine`) },
                  { value: 10, label: context.t(`["receipt/detail/id"].installments.ten`) },
                  { value: 11, label: context.t(`["receipt/detail/id"].installments.eleven`) },
                  { value: 12, label: context.t(`["receipt/detail/id"].installments.twelve`) },
                ]}
                selected={selected_installment ? selected_installment : null}
                handler={(installment) => {
                  setSelectedInstallment(installment);
                }}
              />
            </Column>
            {selected_installment && (
              <Column>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <p style={{ marginRight: "5px" }}>{context.t(`["receipt/detail/id"].payments.title`)}:</p>
                  <p>
                    {Math.round(getInstallmentDiffTotal(selected_installment))}
                    {context.state.currency
                      ? context.state.currency
                      : "₺"} x {selected_installment}
                  </p>
                </div>
              </Column>
            )}
          </>
        </AlertDialog>
        <ListSection className="no-scroll-bar">
          {groupedInstallments.length > 0 ? (
            groupedInstallments.map((group, groupIndex) => (
              <React.Fragment key={`installment-group-${group.matchId}-${groupIndex}`}>
                <Grid className="no-gutters-row" style={{ marginBottom: "10px", borderBottom: "1px solid #e5e5e5", paddingBottom: "5px" }}>
                  <Column className="xs-12 sm-6 md-4 lg-2 mt-1">
                    <MuiThemeProvider theme={themeForDatePicker}>
                      <DatePickerInput
                        disabled
                        label={`${context.t(
                          `['receipt/detail/id'].payments.dateInputLabel`
                        )} / Taksit`}
                        value={
                          new Date(
                            moment(group.installment_date)
                              .local()
                              .toISOString()
                          )
                        }
                        onChange={(installment_date) => {
                          // Gruptaki tüm taksitlerin tarihini güncelle
                          group.installments.forEach(installment => {
                            handleInstallmentChange(installment.id, { ...installment, installment_date });
                          });
                        }}
                      />
                    </MuiThemeProvider>
                  </Column>

                  <Column className="xs-6 sm-6 md-4 lg-3" style={{ marginTop: '0px !important' }}>
                    <Input
                      disabled
                      className="mb-1"
                      label={context.t(
                        `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                      )}
                      value={
                        staffs.find(staff => staff.id === group.installment_staff)?.full_name || ''
                      }
                    />
                  </Column>

                  <Column className="xs-12 sm-6 md-4 lg-3">
                    <Select
                      disabled
                      label={"İşlem Adı"}
                      items={(() => {
                        // Tüm servisleri, paketleri ve ürünleri birleştirerek select options oluştur
                        const allItems = [
                          { label: 'Taksitli Ödeme', value: null, type: null },
                          ...Object.values(checkout_data?.services || {})
                            .filter(service => service !== undefined)
                            .map(service => ({
                              label: services.find(s => s.id === service.service_id)?.name || 'Bilinmeyen Servis',
                              value: service.id,
                              type: 1 // service type
                            })),
                          ...Object.values(checkout_data?.packages || {})
                            .filter(pkg => pkg !== undefined)
                            .map(pkg => ({
                              label: services.find(s => s.id === pkg.service_id)?.name || 'Bilinmeyen Seans',
                              value: pkg.id,
                              type: 2 // package type
                            })),
                          ...Object.values(checkout_data?.groupsAmount || {})
                            .filter(group => group !== undefined)
                            .map(group => ({
                              label: group.package_name || 'Bilinmeyen Paket',
                              value: group.id,
                              type: 2 // package type
                            })),
                          ...Object.values(checkout_data?.sales || {})
                            .filter(sale => sale !== undefined)
                            .map(sale => ({
                              label: stockItems.find(s => s.id === sale.stock_item_id)?.name || 'Bilinmeyen Ürün',
                              value: sale.id,
                              type: 3 // sale type
                            }))
                        ];
                        return allItems;
                      })()}
                      selected={group.installments[0]?.sale_id || null}
                      labelKey="label"
                      valueKey="value"
                      handler={(item) => {
                        // Gruptaki tüm taksitlerin sale_id ve sale_type değerlerini güncelle
                        group.installments.forEach(installment => {
                          const selectedItem = item && typeof item === 'object' ? item :
                            { value: item, type: null };
                          handleInstallmentChange(installment.id, {
                            ...installment,
                            sale_id: selectedItem.value,
                            sale_type: selectedItem.type
                          });
                        });
                      }}
                    />
                  </Column>

                  {/*<Column className="xs-6 sm-6 md-4 lg-2">
                    <Select
                      label={context.t(`["accounting/credit"].headings.is_paid`)}
                      items={[
                        {
                          label: context.t(`receipts.customerStatus.waiting`),
                          value: "0",
                        },
                        {
                          label: context.t(`["accounting/credit"].payments.paid`),
                          value: "1",
                        },
                        {
                          label: context.t(`["accounting/credit"].payments.notPaid`),
                          value: "2",
                        },
                      ]}
                      selected={`${group.installment_status ? group.installment_status : 0}`}
                      labelKey="label"
                      valueKey="value"
                      handler={(installment_status) => {
                        const newStatus = parseInt(installment_status);
                        setSelectedInstallmentStatus(newStatus);

                        // Gruptaki tüm taksitlerin durumunu güncelle
                        const updatedCheckoutData = { ...checkout_data };
                        const updatedInstallments = [];

                        group.installments.forEach(installment => {
                          // Checkout verisini güncelle
                          const installmentKey = Object.keys(checkout_data.installment || {}).find(
                            key => checkout_data.installment[key]?.id === installment.id
                          );

                          if (installmentKey) {
                            updatedCheckoutData.installment[installmentKey] = {
                              ...checkout_data.installment[installmentKey],
                              installment_status: newStatus
                            };

                            // API için taksit verisini hazırla
                            updatedInstallments.push({
                              payment_id: parseInt(installment.id),
                              payment_date: moment(installment.installment_date).toISOString(),
                              payment_type: Number(installment.installment_type),
                              staff_id: parseInt(installment.installment_staff),
                              amount: parseFloat(installment.installment_amount),
                              payment_status: newStatus,
                              sale_id: installment.sale_id,
                              sale_type: installment.sale_type
                            });
                          }
                        });

                        // State'i güncelle
                        setCheckoutData(updatedCheckoutData);

                        // API çağrısını yap
                        singlePaymentAndInstallmentPayment({
                          receipt_id: parseInt(checkout_data?.receipt_id),
                          id: parseInt(group.installments[0].id),
                          receipt_type: 1,
                          is_installment: true,
                          payments: updatedInstallments
                        });
                      }}
                    />
                  </Column>*/}

                  <Column className="xs-6 sm-6 md-4 lg-2">
                    <Input
                      disabled
                      label={
                        group.installment_type === 3
                          ? context.t(
                            `['receipt/detail/id'].payments.pointInputLabel`
                          )
                          : context.t(
                            `['receipt/detail/id'].payments.amountInputLabel`
                          ) +
                          (context.state.currency
                            ? "(" + context.state.currency + ")"
                            : "₺")
                      }
                      type="text"
                      value={installmentInputValues[`installment-${group.matchId}`] !== undefined
                        ? installmentInputValues[`installment-${group.matchId}`]
                        : (group.total_amount ? group.total_amount.toString() : "")}
                      onChange={(e) => {
                        // Sadece input durumunu güncelle, API çağrısını yapma
                        let inputText = e.target.value.replace(/[^\d]/g, '');
                        setInstallmentInputValues({
                          ...installmentInputValues,
                          [`installment-${group.matchId}`]: inputText
                        });
                      }}
                      onBlur={() => {
                        // Input'tan çıkıldığında değeri güncelle
                        if (installmentInputValues[`installment-${group.matchId}`] !== undefined) {
                          // Yeni toplam tutar - kullanıcının girdiği tam değeri al
                          const exactValue = installmentInputValues[`installment-${group.matchId}`] === ''
                            ? 0
                            : parseInt(installmentInputValues[`installment-${group.matchId}`]);

                          // Eğer taksitler varsa güncelle
                          if (group.installments && group.installments.length > 0) {
                            // Son taksiti bul (tamamlanmamış olan)
                            // Varsayılan olarak grup 0. indeksi kullan
                            let referenceInstallmentId = group.installments[0].id;

                            // Eğer birden fazla taksit varsa son taksiti kullan
                            if (group.installments.length > 1) {
                              referenceInstallmentId = group.installments[group.installments.length - 1].id;
                            }

                            // Değişiklik için tam değeri kullan
                            const commonData = {
                              installment_amount: exactValue
                            };

                            // Taksitler grubunun sadece son taksitinde değişiklik yap
                            handleInstallmentChange(referenceInstallmentId, commonData);
                          }
                        }
                      }}
                    />
                  </Column>

                  {/* Sadece grup olan ödemeler için Detay butonu göster */}
                  {group.isGroup ? (
                    <Column className="xs-6 sm-6 md-8 lg-1" style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <div
                        style={{
                          backgroundColor: expandedInstallmentMatch === group.matchId ? '#FF9016' : '#3189EC',
                          borderRadius: '5px',
                          padding: '5px 10px',
                          display: 'flex',
                          marginTop: '-20px',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
                          minWidth: '80px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          if (expandedInstallmentMatch === group.matchId) {
                            setExpandedInstallmentMatch(null);
                          } else {
                            setExpandedInstallmentMatch(group.matchId);
                          }
                        }}
                      >
                        {expandedInstallmentMatch === group.matchId ? (
                          <>
                            <ExpandLessIcon style={{ color: 'white', fontSize: '20px', marginRight: '3px' }} />
                            <span style={{ color: 'white', fontSize: '12px' }}>Gizle</span>
                          </>
                        ) : (
                          <>
                            <ExpandMoreIcon style={{ color: 'white', fontSize: '20px', marginRight: '3px' }} />
                            <span style={{ color: 'white', fontSize: '12px' }}>Detay ({group.installment_count})</span>
                          </>
                        )}
                      </div>
                    </Column>
                  ) : (
                    // Grup değilse silme butonu göster
                    <Column className="xs-3 sm-3 md-2 lg-1" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Delete
                        onClick={() => deleteSingleReceiptPayment(checkout_data.receipt_id, group.installments[0].id)}
                        style={{
                          cursor: "pointer",
                          color: "red",
                          fontSize: "24px"
                        }}
                      />
                    </Column>
                  )}
                </Grid>

                {/* Detay gösterimi */}
                {expandedInstallmentMatch === group.matchId && (
                  <div style={{ marginLeft: '20px', marginBottom: '20px', borderLeft: '2px solid #3189EC', paddingLeft: '10px' }}>
                    {group.installments.map((installment, index) => (
                      <Grid className="no-gutters-row" key={`installment-detail-${installment.id}-${index}`} style={{ marginBottom: '10px' }}>
                        <Column className="xs-12 sm-12 md-12 lg-3">
                          <Input
                            label={`Taksit Tarihi / ${index + 1}. Taksit`}
                            value={moment(installment.installment_date).format('DD/MM/YYYY')}
                            onChange={(e) => {
                              if (moment(e.target.value, 'DD/MM/YYYY', true).isValid()) {
                                handleInstallmentChange(installment.id, {
                                  ...installment,
                                  installment_date: moment(e.target.value, 'DD/MM/YYYY').toISOString()
                                });
                              }
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Select
                            label={'Taksit Durumu'}
                            items={[
                              {
                                label: context.t(`receipts.customerStatus.waiting`),
                                value: "0",
                              },
                              {
                                label: context.t(`["accounting/credit"].payments.paid`),
                                value: "1",
                              },
                              {
                                label: context.t(`["accounting/credit"].payments.notPaid`),
                                value: "2",
                              },
                            ]}
                            selected={`${installment.installment_status}`}
                            labelKey="label"
                            valueKey="value"
                            handler={(installment_status) => {
                              handleInstallmentChange(installment.id, {
                                ...installment,
                                installment_status: parseInt(installment_status)
                              });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Select
                            label={'İşlem Adı'}
                            items={(() => {
                              // Tüm servisleri, paketleri ve ürünleri birleştirerek select options oluştur
                              const allItems = [
                                { label: 'Taksitli Ödeme', value: null, type: null },
                                ...Object.values(checkout_data?.services || {})
                                  .filter(service => service !== undefined)
                                  .map(service => ({
                                    label: services.find(s => s.id === service.service_id)?.name || 'Bilinmeyen Servis',
                                    value: service.id,
                                    type: 1 // service type
                                  })),
                                ...Object.values(checkout_data?.packages || {})
                                  .filter(pkg => pkg !== undefined)
                                  .map(pkg => ({
                                    label: services.find(s => s.id === pkg.service_id)?.name || 'Bilinmeyen Seans',
                                    value: pkg.id,
                                    type: 2 // package type
                                  })),
                                ...Object.values(checkout_data?.groupsAmount || {})
                                  .filter(group => group !== undefined)
                                  .map(group => ({
                                    label: group.package_name || 'Bilinmeyen Paket',
                                    value: group.id,
                                    type: 2 // package type
                                  })),
                                ...Object.values(checkout_data?.sales || {})
                                  .filter(sale => sale !== undefined)
                                  .map(sale => ({
                                    label: stockItems.find(s => s.id === sale.stock_item_id)?.name || 'Bilinmeyen Ürün',
                                    value: sale.id,
                                    type: 3 // sale type
                                  }))
                              ];
                              return allItems;
                            })()}
                            selected={installment.sale_id || null}
                            labelKey="label"
                            valueKey="value"
                            handler={(item) => {
                              const selectedItem = item && typeof item === 'object' ? item :
                                { value: item, type: null };
                              handleInstallmentChange(installment.id, {
                                ...installment,
                                sale_id: selectedItem.value,
                                sale_type: selectedItem.type
                              });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Input
                            disabled
                            label={'Ödeme Türü'}
                            value={
                              installment.installment_type === 0
                                ? context.t(`['receipt/detail/id'].payments.typeCASH`)
                                : installment.installment_type === 1
                                  ? context.t(`['receipt/detail/id'].payments.typeCARD`)
                                  : installment.installment_type === 2
                                    ? context.t(`['receipt/detail/id'].payments.typeEFT`)
                                    : context.t(`['receipt/detail/id'].payments.typePOINT`)
                            }
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-2">
                          <Input
                            label={'Taksit Tutarı'}
                            value={installment.installment_amount !== null ? installment.installment_amount.toString() : ""}
                            onChange={(e) => {
                              const inputValue = e.target.value.replace(/[^\d]/g, ''); // Sadece sayıları kabul et
                              const value = inputValue === '' ? 0 : parseFloat(inputValue);

                              // Önce state'i güncelle
                              const updatedCheckoutData = {
                                ...checkout_data,
                                installment: {
                                  ...checkout_data.installment,
                                  [Object.keys(checkout_data.installment).find(
                                    key => checkout_data.installment[key]?.id === installment.id
                                  )]: {
                                    ...installment,
                                    installment_amount: value
                                  }
                                }
                              };
                              setCheckoutData(updatedCheckoutData);

                              // Debounce ile API çağrısını yap
                              setPendingUpdate({
                                installmentId: installment.id,
                                installmentKey: Object.keys(checkout_data.installment).find(
                                  key => checkout_data.installment[key]?.id === installment.id
                                ),
                                data: {
                                  installment_amount: value
                                }
                              });
                            }}
                          />
                        </Column>
                        <Column className="xs-12 sm-12 md-12 lg-1">
                          <Delete onClick={() => {
                            deleteSingleReceiptPayment(checkout_data.receipt_id, installment.id);
                          }} size="small" style={{ cursor: "pointer", color: "red", width: "20px", height: "20px", marginTop: "15px" }} />
                        </Column>

                        {installment.sale_id !== null && (
                          <Column className="xs-12 sm-12 md-12 lg-12">

                          </Column>
                        )}
                      </Grid>
                    ))}
                  </div>
                )}
              </React.Fragment>
            ))
          ) : (
            <NoDataContainer style={{ height: "90%" }}>
              <img
                style={{ height: "80%" }}
                src={require("../../../../assets/images/manypixels/online_payment_.svg")}
                alt="Malesef bulunamadı!"
              />
              <p>{context.t(`['receipt/detail/id'].payments.noDataText`)}</p>
            </NoDataContainer>
          )}
        </ListSection>
      </SectionBox >
    </>
  );
};

// Randevu notu gösterildiği düzenlendiği alan.

export const _AppNotesBuilder = ({
  receipt_sender,
  setAddSmsDialog,
  setMessage,
  customer_note,
}) => {
  const context = useContext(AppContext);
  const getMessageByLanguage = (context) => {
    const lang = context.state.default_locale || 'tr';
    const messages = {
      tr: `Sayın ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"} ödemeniz için teşekkür ederiz. Kalan borcunuz ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}'dir. Sağlıklı günler dileriz.`,

      en: `Dear ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, thank you for your payment of ${context.state.currency ? context.state.currency : "₺"}${context.t(`sms.send.autoTextShortCode.paidDebt`)}. Your remaining balance is ${context.state.currency ? context.state.currency : "₺"}${context.t(`sms.send.autoTextShortCode.remainingDebt`)}. Have a healthy day.`,

      ar: `عزيزي ${context.t(`sms.send.autoTextShortCode.nameSurname`)}، نشكرك على دفعة ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"}. رصيدك المتبقي هو ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}. نتمنى لك يوماً صحياً.`,

      ru: `Уважаемый ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, благодарим вас за оплату ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"}. Ваш остаток составляет ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}. Желаем вам здорового дня.`
    };

    return messages[lang] || messages.tr; // Eğer dil bulunamazsa Türkçe mesaj döner
  };


  return (
    <SectionBox style={{ height: "auto" }}>
      <Grid className="no-gutters-row">
        <Column
          className={`sx-12 sm-12 md-12 lg-${receipt_sender !== null ? "7" : "12"
            }`}
        >
          <SectionHeading
            style={{
              backgroundColor: "rgba(140,15,180, 0.1)",
              color: "#8c0fb4",
              border: "1px solid #8c0fb4",
              padding: "10px",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Comment />
              <h3 style={{ marginLeft: "15px" }}>
                {context.t(`['receipt/detail/id'].notes.customer`)}
              </h3>
            </div>
          </SectionHeading>
        </Column>
        <Column className="xs-12 sm-12 md-12 lg-5">
          {receipt_sender !== null ? (
            <SectionHeading
              onClick={() => {
                setAddSmsDialog(true);
                setMessage(getMessageByLanguage(context));
              }}
              style={{
                cursor: "pointer",
                backgroundColor: "rgba(255,165,0, 0.1)",
                color: "orange",
                border: "1px solid orange",
                padding: "10px",
                borderRadius: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                whiteSpace: "nowrap",
                position: "relative",
              }}
            ><span
              className="bg-orange"
              style={{
                position: 'absolute',
                right: -1,
                top: -9,
                color: 'white',
                padding: '2px 7px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: 'bold'
              }}
            >
                {context.t(`appointments.detail.statusNew`)}
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Sms />
                <h3 style={{ marginLeft: "15px" }}>
                  {context.t(`['receipt/detail/id'].sms.addSmsButtonTitle`)}
                </h3>
              </div>
            </SectionHeading>
          ) : (
            <></>
          )}
        </Column>
        <Column className="xs-12 sm-auto">
          <Input
            disabled
            multiline
            rows={8}
            // label={context.t(`['receipt/detail/id'].notes.customer`)}
            value={customer_note ?? null}
          />
        </Column>
      </Grid>
    </SectionBox>
  );
};

// Müşteri notlarının gösterildiği düzenlendiği alan.

export const _CusNotesBuilder = ({ receipt_note, setReceiptNote }) => {
  const context = useContext(AppContext);
  return (
    <SectionBox style={{ height: "auto" }}>
      <Grid className="no-gutters-row">
        <Column className="sx-12 sm-12 md-12 lg-12">
          <SectionHeading
            style={{
              backgroundColor: "rgba(140,15,180, 0.1)",
              color: "#8c0fb4",
              border: "1px solid #8c0fb4",
              padding: "10px",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Receipt />
              <h3 style={{ marginLeft: "15px" }}>
                {context.t(`['receipt/detail/id'].notes.receipt`)}
              </h3>
            </div>
          </SectionHeading>
        </Column>
        <Column className="xs-12 sm-auto">
          <Input
            // label={context.t(`['receipt/detail/id'].notes.receipt`)}
            multiline
            inputProps={{ maxLength: 255 }}
            rows={7}
            placeholder={context.t(`['receipt/detail/id'].notes.receiptPlaceholder`)}
            value={receipt_note ?? null}
            onChange={(e) => {
              setReceiptNote(e.target.value);
            }}
            helperText={`${context.t(`["receipt/detail/id"].charLimitTitle`)} ${255 - parseInt(receipt_note.length)
              }`}
          />
        </Column>
      </Grid>

      {/* {appointment_note && (
        <Column className="xs-12 sm-auto">
          <Input
            disabled
            multiline
            rows={3}
            label={context.t(`['receipt/detail/id'].notes.appointment`)}
            value={appointment_note ?? null}
          />
        </Column>
      )} */}
    </SectionBox>
  );
};

// Otomatik Randevu oluşturmak için açılan dialog.

export const _AutoAppointmentDialogBuilder = ({
  checkout_data_dialog,
  setCheckoutDataDialog,
  availableAppointmentExpanded,
  setAvailableAppointmentExpanded,
  selected_date,
  selected_staff,
  staffs,
  selected_service,
  services,
  selected_customer,
  send_sms,
  setSendSms,
  selected_description,
  setNote,
  getStaffUnavailableHours,
  setSelectedTime,
  hoursData,
  selected_time,
  setAdjSelectedDate,
  insertAppointment,
}) => {
  const context = useContext(AppContext);
  return (
    <FullScreenDialog
      className="appointment-add-dialog"
      maxWidth="md"
      fullWidth
      receiptOk={true}
      open={checkout_data_dialog}
      onClose={() => {
        setCheckoutDataDialog(false);
        setAvailableAppointmentExpanded(false);
      }}
      title={context.t(`appointments.create.title`)}
    // buttons={[
    //   {
    //     title: context.t(`appointments.create.completeButtonTitle`),
    //     icon: "check",
    //     backgroundColor: "primary-opacity",
    //     textColor: "primary",
    //     disabledHandleClose: true,
    //     onClick: () => {
    //       setTimeout(() => {
    //         insertAppointment();
    //       }, 1000);
    //     },
    //   },
    //   {
    //     title: context.t(`appointments.create.discardButtonTitle`),
    //     icon: "close",
    //     textColor: "grey",
    //     onClick: () => {
    //       setState({ availableAppointmentExpanded: false });
    //     },
    //   },
    // ]}
    >
      <Grid style={{ marginTop: "20px" }}>
        <Column className="xs-6 sm-6">
          <Column className="xs-12 sm-12 md-auto">
            <div>
              <h5
                style={{
                  background: "#eff6fe",
                  color: "#4293ed",
                  padding: "15px",
                  fontSize: "20px",
                }}
              >
                {moment(selected_date).format("DD MMMM dddd YYYY")}
              </h5>
            </div>
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Input
              className="mb-1"
              readOnly
              label={context.t(`appointments.create.selectedStaffInputLabel`)}
              value={
                selected_staff
                  ? staffs.filter((staff) => staff.id === selected_staff).length
                    ? staffs.filter((staff) => staff.id === selected_staff)[0]
                      .full_name
                    : "Silinmiş Hizmet"
                  : "Silinmiş Hizmet"
              }
            />
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Input
              className="mb-1"
              readOnly
              label={context.t(`appointments.create.selectedServiceInputLabel`)}
              value={
                selected_service
                  ? services.filter(
                    (service) => service.id === selected_service
                  ).length
                    ? services.filter(
                      (service) => service.id === selected_service
                    )[0].name
                    : "Silinmiş Hizmet"
                  : "Silinmiş Hizmet"
              }
            />
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Input
              className="mb-1"
              readOnly
              label={context.t(
                `appointments.create.selectedCustomerInputLabel`
              )}
              value={selected_customer}
            />
          </Column>
        </Column>
        <Column className="xs-6 sm-6">
          <Column className="xs-12 sm-12 md-auto">
            <CSwitch
              label={context.t(`appointments.create.sendSmsInputLabel`)}
              checked={send_sms}
              color="primary"
              disabled={
                selected_customer && selected_customer.send_sms === false
              }
              onChange={(checked) => {
                setSendSms(checked.target.checked);
              }}
            />
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Input
              className="mt-2 mb-1"
              readOnly
              label={context.t(`appointments.create.description`)}
              value={selected_description}
            />
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Input
              label={context.t(`appointments.create.noteInputLabel`)}
              multiline
              rows={1}
              onChange={(e) => setNote(e.target.value)}
            />
          </Column>
          <Column className="xs-12 sm-12 md-auto">
            <Button
              icon="event"
              backgroundColor="primary"
              fullWidth
              textColor="white"
              title={context.t(
                `['appointments/add'].availableHoursButtonTitle`
              )}
              onClick={() => {
                getStaffUnavailableHours();
                setSelectedTime(null);
              }}
            />
          </Column>
        </Column>
      </Grid>

      {/* Time Select */}
      {availableAppointmentExpanded === true ? (
        <>
          <Grid className="p-2" style={{ width: "fit-content" }}>
            {BetweenTimeGenerator(context.state.company_shift).map(
              (item, index) => {
                const time = item.split(":");
                const x = new Date(selected_date).setHours(
                  time[0],
                  time[1],
                  0,
                  0
                );
                return (
                  <div
                    key={index}
                    className="col xs-1 sm-1 md-1 lg-1 xl-1 mb-1 mx-3"
                    style={{
                      cursor: `${hoursData.day_closed ||
                        hoursData.closed_hours.includes(item)
                        ? hoursData.trans_hours.includes(item)
                          ? "not-allowed"
                          : "pointer"
                        : "pointer"
                        }`,
                      margin: "5px 3px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30px",
                      maxWidth: "120px",
                      borderRadius: "20px",
                      border: `${hoursData.day_closed ||
                        hoursData.closed_hours.includes(item)
                        ? hoursData.trans_hours.includes(item)
                          ? "1px solid gray"
                          : "1px solid purple"
                        : hoursData.occupied_hours.includes(item)
                          ? hoursData.appointment_hours.includes(item)
                            ? "1px solid red"
                            : "1px solid purple"
                          : "1px solid green"
                        }`,
                      backgroundColor: `${(hoursData.day_closed ||
                        hoursData.closed_hours.includes(item)) &&
                        selected_time === item
                        ? hoursData.trans_hours.includes(item)
                          ? "gray"
                          : "purple"
                        : hoursData.occupied_hours.includes(item) &&
                          selected_time === item
                          ? hoursData.appointment_hours.includes(item)
                            ? "red"
                            : "purple"
                          : selected_time === item
                            ? "green"
                            : "white"
                        }`,
                      color: `${selected_time === item
                        ? "white"
                        : hoursData.day_closed ||
                          hoursData.closed_hours.includes(item)
                          ? hoursData.trans_hours.includes(item)
                            ? "gray"
                            : "purple"
                          : hoursData.occupied_hours.includes(item)
                            ? hoursData.appointment_hours.includes(item)
                              ? "red"
                              : "purple"
                            : "green"
                        }`,
                    }}
                    onClick={() => {
                      if (item.split(":")[0] < 6) {
                        setAdjSelectedDate(moment(selected_date).add(1, "day"));
                      } else {
                        setAdjSelectedDate(selected_date);
                      }
                      if (
                        !(
                          hoursData.day_closed ||
                          (hoursData.closed_hours.includes(item) &&
                            hoursData.trans_hours.includes(item))
                        )
                      ) {
                        setSelectedTime(item);
                      }
                    }}
                  >
                    {item}
                  </div>
                );
              }
            )}
          </Grid>
          <Grid>
            <MuiThemeProvider theme={theme}>
              <Tooltip
                style={{ backgroundColor: "white", marginLeft: "30px" }}
                title={
                  <Column
                    style={{ backgroundColor: "white" }}
                    className="xs-12 sm-12 p-2"
                  >
                    <Column className="xs-12 sm-12">
                      <ColorMean>
                        <div className="color" style={{ background: "green" }}>
                          <div className="overlay" />
                        </div>
                        <span>
                          {context.t(`["receipt/detail/id"].greenHourTitle`)}
                        </span>
                      </ColorMean>
                    </Column>
                    <Column className="xs-12 sm-12 mt-2">
                      <ColorMean>
                        <div className="color" style={{ background: "red" }}>
                          <div className="overlay" />
                        </div>
                        <span>
                          {context.t(`["receipt/detail/id"].redHourTitle`)}
                        </span>
                      </ColorMean>
                    </Column>
                    <Column className="xs-12 sm-12 mt-2">
                      <ColorMean>
                        <div className="color" style={{ background: "orange" }}>
                          <div className="overlay" />
                        </div>
                        <span>
                          {context.t(`["receipt/detail/id"].orangeHourTitle`)}
                        </span>
                      </ColorMean>
                    </Column>
                  </Column>
                }
                placement="right"
              >
                <IconButton>
                  <InfoOutlined />
                </IconButton>
              </Tooltip>
            </MuiThemeProvider>
          </Grid>

          <Grid>
            {selected_time && (
              <Button
                style={{ margin: "-20px auto 15px" }}
                icon="check"
                title={context.t(
                  `['appointments/add'].confirmButtonHoursTitle`
                )}
                backgroundColor="primary"
                textColor="white"
                onClick={() => {
                  setAvailableAppointmentExpanded(false);
                  setTimeout(() => {
                    insertAppointment();
                  }, 500);
                }}
              />
            )}
          </Grid>
        </>
      ) : (
        <></>
      )}
    </FullScreenDialog>
  );
};

/**
 * Borç Bilgilendirme / Tahsilat mesajı Göndermek için açılan dialog.
 */
export const _DebtInformationDialogBuilder = ({
  message,
  setMessage,
  add_sms_dialog,
  setAddSmsDialog,
  setAlertMessageDialog,
}) => {
  const context = useContext(AppContext);
  const [selectedLanguage, setSelectedLanguage] = useState(context.state.default_locale); // Yeni state ekledik
  const getMessageByLanguage = (context) => {
    const lang = context.state.default_locale || 'tr';
    const messages = {
      tr: `Sayın ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"} ödemeniz için teşekkür ederiz. Kalan borcunuz ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}'dir. Sağlıklı günler dileriz.`,

      en: `Dear ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, thank you for your payment of ${context.state.currency ? context.state.currency : "₺"}${context.t(`sms.send.autoTextShortCode.paidDebt`)}. Your remaining balance is ${context.state.currency ? context.state.currency : "₺"}${context.t(`sms.send.autoTextShortCode.remainingDebt`)}. Have a healthy day.`,

      ar: `عزيزي ${context.t(`sms.send.autoTextShortCode.nameSurname`)}، نشكرك على دفعة ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"}. رصيدك المتبقي هو ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}. نتمنى لك يوماً صحياً.`,

      ru: `Уважаемый ${context.t(`sms.send.autoTextShortCode.nameSurname`)}, благодарим вас за оплату ${context.t(`sms.send.autoTextShortCode.paidDebt`)} ${context.state.currency ? context.state.currency : "₺"}. Ваш остаток составляет ${context.t(`sms.send.autoTextShortCode.remainingDebt`)} ${context.state.currency ? context.state.currency : "₺"}. Желаем вам здорового дня.`
    };

    return messages[lang] || messages.tr; // Eğer dil bulunamazsa Türkçe mesaj döner
  };

  return (
    <AlertDialog
      fullWidth
      maxWidth="sm"
      title={context.t(`['receipt/detail/id'].sms.smsButtonTitle`)}
      open={add_sms_dialog}
      closeHandler={() => setAddSmsDialog(false)}
      buttons={[
        {
          title: context.t(`['receipt/detail/id'].sms.sendButtonTitle`),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          onClick: () => {
            setMessage(message);
            setAlertMessageDialog(true);
          },
        },
        {
          title: context.t(`['receipt/detail/id'].sms.discardButtonTitle`),
          icon: "close",
          textColor: "grey",
          onClick: () => {
            setMessage("");
          },
        },
      ]}
    >
      <Column className="xs-12 sm-12 md-12 lg-12">

        <Label>{context.t(`['receipt/detail/id'].sms.languageLabel`)}</Label>
        <LanguageContainer>
          <LanguageButton
            active={selectedLanguage === 'tr'}
            onClick={() => {
              setSelectedLanguage('tr');
              setMessage(getMessageByLanguage({ ...context, state: { ...context.state, default_locale: 'tr' } }));
            }}
          >
            <Flag src={require(`../../../../assets/images/flags/tr.svg`)} />
            <span>Türkçe</span>
          </LanguageButton>

          <LanguageButton
            active={selectedLanguage === 'en'}
            onClick={() => {
              setSelectedLanguage('en');
              setMessage(getMessageByLanguage({ ...context, state: { ...context.state, default_locale: 'en' } }));
            }}
          >
            <Flag src={require(`../../../../assets/images/flags/en.svg`)} />
            <span>English</span>
          </LanguageButton>

          <LanguageButton
            active={selectedLanguage === 'ar'}
            onClick={() => {
              setSelectedLanguage('ar');
              setMessage(getMessageByLanguage({ ...context, state: { ...context.state, default_locale: 'ar' } }));
            }}
          >
            <Flag src={require(`../../../../assets/images/flags/ar.svg`)} />
            <span>العربية</span>
          </LanguageButton>

          <LanguageButton
            active={selectedLanguage === 'ru'}
            onClick={() => {
              setSelectedLanguage('ru');
              setMessage(getMessageByLanguage({ ...context, state: { ...context.state, default_locale: 'ru' } }));
            }}
          >
            <Flag src={require(`../../../../assets/images/flags/ru.svg`)} />
            <span>Русский</span>
          </LanguageButton>
        </LanguageContainer>

        <Input
          label={context.t(`sms.send.messageInputLabel`)}
          multiline={true}
          rows={10}
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          helperText={CalculateMessageCharCount(message, "1")}
        />
        <Button
          title={context.t(`sms.send.autoText.nameSurname`)}
          size="xs"
          textColor="primary"
          outlined
          onClick={() => {
            setMessage(`${message} ${context.t(`sms.send.autoTextShortCode.nameSurname`)}`);
          }}
        />
        <Button
          className="ml-1"
          title={context.t(`sms.send.autoText.amountPaid`)}
          size="xs"
          textColor="primary"
          outlined
          onClick={() => {
            setMessage(`${message} ${context.t(`sms.send.autoTextShortCode.paidDebt`)}`);
          }}
        />
        <Button
          className="ml-1"
          title={context.t(`sms.send.autoText.remainingDebt`)}
          size="xs"
          textColor="primary"
          outlined
          onClick={() => {
            setMessage(`${message} ${context.t(`sms.send.autoTextShortCode.remainingDebt`)}`);
          }}
        />
        <Button
          className="ml-1"
          title={context.t(`sms.send.autoText.businessUrl`)}
          size="xs"
          textColor="primary"
          outlined
          onClick={() => {
            setMessage(`${message} ${context.t(`sms.send.autoTextShortCode.businessUrl`)}`);
          }}
        />

      </Column>
    </AlertDialog>
  );
};

/**
 * İndirim uygulamak için açılan dialog.
 */
export const _DiscountDialogBuilder = ({
  discount_modal,
  setDiscountModal,
  applyDiscount,
  discount_type,
  setDiscountType,
  discount_value,
  setDiscountValue,
}) => {
  const context = useContext(AppContext);
  return (
    <AlertDialog
      fullWidth
      maxWidth="sm"
      title={context.t(`['receipt/detail/id'].applyDiscountButtonTitle`)}
      open={discount_modal}
      closeHandler={() => setDiscountModal(false)}
      buttons={[
        {
          title: context.t(`['receipt/detail/id'].applyDiscountButtonTitle`),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          onClick: () =>
            applyDiscount({
              type: discount_type,
              value: discount_value,
            }),
        },
        {
          title: context.t(
            `['receipt/detail/id'].applyDiscount.discardButtonTitle`
          ),
          icon: "close",
          textColor: "grey",
        },
      ]}
    >
      <Select
        label={context.t(`['receipt/detail/id'].applyDiscount.typeInputLabel`)}
        items={[
          {
            label:
              (context.state.currency
                ? context.state.currency === "₺"
                  ? "TL"
                  : context.state.currency
                : "TL") +
              context.t(`['receipt/detail/id'].applyDiscount.typeCASH`),
            value: "TL",
          },
          {
            label: context.t(`['receipt/detail/id'].applyDiscount.typePERCENT`),
            value: "%",
          },
        ]}
        labelKey="label"
        valueKey="value"
        selected={discount_type}
        handler={(discountType) => {
          setDiscountType(discountType);
        }}
      />

      <Input
        label={`${context.t(
          `['receipt/detail/id'].applyDiscount.amountInputLabel`
        )} (${context.state.currency ? context.state.currency : discount_type
          })`}
        type="number"
        value={discount_value}
        onChange={(e) => {
          setDiscountValue(
            /[0-9,.]+/.test(e.target.value) ? Math.abs(e.target.value) : 0
          );
        }}
      />
    </AlertDialog>
  );
};

/**
 * Adisyonu silmek için açılan onay dialog'u.
 */
export const _ReceiptDeleteDialogBuilder = ({
  delete_confirm,
  setDeleteConfirm,
  delete_id,
  deleteSingleReceipt,
}) => {
  const context = useContext(AppContext);
  return (
    <AlertDialog
      open={delete_confirm}
      closeHandler={() => setDeleteConfirm(false)}
      title={context.t(`['receipt/detail/id'].delete.title`)}
      buttons={[
        {
          title: context.t(`['receipt/detail/id'].delete.confirmButtonTitle`),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          timer: 5,
          onClick: () => deleteSingleReceipt(delete_id),
        },
        {
          title: context.t(`['receipt/detail/id'].delete.discardButtonTitle`),
          icon: "close",
          textColor: "grey",
        },
      ]}
    >
      <Alert severity="warning">
        {context.t(`['receipt/detail/id'].delete.alertText`)}
      </Alert>
    </AlertDialog>
  );
};

const SectionBox = styled.div`
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  padding-top: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  color: var(--dark-primary);

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const ListSection = styled.div`
  overflow-x: scroll;
  margin-bottom: auto;
  padding-left: 5px;
  padding-right: 5px;
`;

const PaymentSection = styled.div`
  width: 95%;
  height: 57px;
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
`;

const SubTotalText = styled.div`
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const CustomerBoxDiv = styled.div`
  width: 100%;
  height: 57px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    margin-top: 7px;
    margin-left: 10px;
  }
`;

const CustomerPointBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  margin-top: 5px;

  h3 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    color: #3c3c3c;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;

    b {
      font-size: 13px;
      font-weight: 400;
      color: #aaa;
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 16px;

  img {
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
  }
  p {
    color: #407bff;
    font-size: 18px;
    font-weight: 500;
    padding-top: 16px;
    text-align: center;
  }
`;

const AdvancedType = styled.div`
  display: flex;
  width: 190px;
  height: 88px;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
`;

const ColorMean = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  justify-content: center;

  &:nth-last-child(1) {
    margin: 0;
  }

  div.color {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    margin-right: 8px;

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        -180deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  span {
    flex: 1;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
    color: #000000;
  }
`;

const ReceiptProfile = styled.div`
  display: flex;
  flex-direction: column;
  height: 57px;
  width: 100%;
  border-radius: 5px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 100%;
    padding: 2px;
  }
`;

const Flag = styled.img`
  width: 22px;
  height: 22px;
  object-fit: cover;
`;

// Styled components
const LanguageContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid ${props => props.active ? '#3189ec' : '#ddd'};
  background-color: ${props => props.active ? 'rgba(49,137,236,0.08)' : 'white'};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3189ec;
  }

  span {
    color: ${props => props.active ? '#3189ec' : '#666'};
    font-size: 14px;
  }
`;

const Label = styled.label`
  font-size: 0.775rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  padding: 0;
  margin-bottom: 5px;
  position: relative;
  display: block;
  transform-origin: top left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
`;